export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_ERROR = 'LOGOUT_USER_ERROR';

export const SUPERADMIN_SKILL_LIST = 'SUPERADMIN_SKILL_LIST';
export const SUPERADMIN_SKILL_LIST_SUCCESS = 'SUPERADMIN_SKILL_LIST_SUCCESS';
export const SUPERADMIN_SKILL_LIST_ERROR = 'SUPERADMIN_SKILL_LIST_ERROR';

export const SUPERADMIN_SKILL_ADD = 'SUPERADMIN_SKILL_ADD';
export const SUPERADMIN_SKILL_ADD_SUCCESS = 'SUPERADMIN_SKILL_ADD_SUCCESS';
export const SUPERADMIN_SKILL_ADD_ERROR = 'SUPERADMIN_SKILL_ADD_ERROR';

export const SUPERADMIN_SKILL_EDIT = 'SUPERADMIN_SKILL_EDIT';
export const SUPERADMIN_SKILL_EDIT_SUCCESS = 'SUPERADMIN_SKILL_EDIT_SUCCESS';
export const SUPERADMIN_SKILL_EDIT_ERROR = 'SUPERADMIN_SKILL_EDIT_ERROR';

export const SUPERADMIN_SKILL_UPDATE   = 'SUPERADMIN_SKILL_UPDATE';
export const SUPERADMIN_SKILL_UPDATE_SUCCESS = "SUPERADMIN_SKILL_UPDATE_SUCCESS";
export const SUPERADMIN_SKILL_UPDATE_ERROR = "SUPERADMIN_SKILL_UPDATE_ERROR";

export const SUPERADMIN_SKILL_DELETE = 'SUPERADMIN_SKILL_DELETE';
export const SUPERADMIN_SKILL_DELETE_SUCCESS = 'SUPERADMIN_SKILL_DELETE_SUCCESS';
export const SUPERADMIN_SKILL_DELETE_ERROR = 'SUPERADMIN_SKILL_DELETE_ERROR';

export const SUPERADMIN_SUBSECTOR_LIST = 'SUPERADMIN_SUBSECTOR_LIST';
export const SUPERADMIN_SUBSECTOR_LIST_SUCCESS = 'SUPERADMIN_SUBSECTOR_LIST_SUCCESS';
export const SUPERADMIN_SUBSECTOR_LIST_ERROR = 'SUPERADMIN_SUBSECTOR_LIST_ERROR';

export const SA_TRAVEL_FIELDS_MASTER_LIST           = 'SA_TRAVEL_FIELDS_MASTER_LIST';
export const SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS   = 'SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS';
export const SA_TRAVEL_FIELDS_MASTER_LIST_ERROR     = 'SA_TRAVEL_FIELDS_MASTER_LIST_ERROR';

export const SA_TRAVEL_FIELDS_MASTER_CREATE           = 'SA_TRAVEL_FIELDS_MASTER_CREATE';
export const SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS   = 'SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS';
export const SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR     = 'SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR';

export const SA_TRAVEL_FIELDS_MASTER_MODIFY           = 'SA_TRAVEL_FIELDS_MASTER_MODIFY';
export const SA_TRAVEL_FIELDS_MASTER_MODIFY_SUCCESS   = 'SA_TRAVEL_FIELDS_MASTER_MODIFY_SUCCESS';
export const SA_TRAVEL_FIELDS_MASTER_MODIFY_ERROR     = 'SA_TRAVEL_FIELDS_MASTER_MODIFY_ERROR';

export const SA_TRAVEL_FIELDS_MASTER_DELETE           = 'SA_TRAVEL_FIELDS_MASTER_DELETE';
export const SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS   = 'SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS';
export const SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR     = 'SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR';

export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';
export const EMAIL_VERIFICATION_ERROR = 'EMAIL_VERIFICATION_ERROR';

export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';

export const ROLES_LIST = 'ROLES_LIST';
export const ROLES_LIST_SUCCESS = 'ROLES_LIST_SUCCESS';
export const ROLES_LIST_ERROR = 'ROLES_LIST_ERROR'; 

export const ROLES_ADD = 'ROLES_ADD';
export const ROLES_ADD_SUCCESS = 'ROLES_ADD_SUCCESS';
export const ROLES_ADD_ERROR = 'ROLES_ADD_ERROR';

export const ROLES_EDIT = 'ROLES_EDIT';
export const ROLES_EDIT_SUCCESS = 'ROLES_EDIT_SUCCESS';
export const ROLES_EDIT_ERROR = 'ROLES_EDIT_ERROR';

export const ROLES_UPDATE   = 'ROLES_UPDATE';
export const ROLES_UPDATE_SUCCESS = "ROLES_UPDATE_SUCCESS";
export const ROLES_UPDATE_ERROR = "ROLES_UPDATE_ERROR";

export const ROLES_DELETE = 'ROLES_DELETE';
export const ROLES_DELETE_SUCCESS = 'ROLES_DELETE_SUCCESS';
export const ROLES_DELETE_ERROR = 'ROLES_DELETE_ERROR'; 

export const ROLES_PERMISSION_EDIT = 'ROLES_PERMISSION_EDIT';
export const ROLES_PERMISSION_EDIT_SUCCESS = 'ROLES_PERMISSION_EDIT_SUCCESS';
export const ROLES_PERMISSION_EDIT_ERROR = 'ROLES_PERMISSION_EDIT_ERROR'; 

export const ROLES_PERMISSION_UPDATE = 'ROLES_PERMISSION_UPDATE';
export const ROLES_PERMISSION_UPDATE_SUCCESS = 'ROLES_PERMISSION_UPDATE_SUCCESS';
export const ROLES_PERMISSION_UPDATE_ERROR = 'ROLES_PERMISSION_UPDATE_ERROR'; 

export const SECTOR_LIST_SUPERADMIN         = 'SECTOR_LIST_SUPERADMIN';
export const SECTOR_LIST_SUPERADMIN_SUCCESS = "SECTOR_LIST_SUPERADMIN_SUCCESS";
export const SECTOR_LIST_SUPERADMIN_ERROR   = "SECTOR_LIST_SUPERADMIN_ERROR";

export const SECTOR_ADD_SUPERADMIN    = 'SECTOR_ADD_SUPERADMIN';
export const SECTOR_ADD_SUPERADMIN_SUCCESS = "SECTOR_ADD_SUPERADMIN_SUCCESS";
export const SECTOR_ADD_SUPERADMIN_ERROR = "SECTOR_ADD_SUPERADMIN_ERROR";

export const SECTOR_EDIT_SUPERADMIN   = 'SECTOR_EDIT_SUPERADMIN';
export const SECTOR_EDIT_SUPERADMIN_SUCCESS = "SECTOR_EDIT_SUPERADMIN_SUCCESS";
export const SECTOR_EDIT_SUPERADMIN_ERROR = "SECTOR_EDIT_SUPERADMIN_ERROR";

export const SECTOR_UPDATE_SUPERADMIN   = 'SECTOR_UPDATE_SUPERADMIN';
export const SECTOR_UPDATE_SUPERADMIN_SUCCESS = "SECTOR_UPDATE_SUPERADMIN_SUCCESS";
export const SECTOR_UPDATE_SUPERADMIN_ERROR = "SECTOR_UPDATE_SUPERADMIN_ERROR";

export const SECTOR_DELETE_SUPERADMIN         = 'SECTOR_DELETE_SUPERADMIN';
export const SECTOR_DELETE_SUPERADMIN_SUCCESS = "SECTOR_DELETE_SUPERADMIN_SUCCESS";
export const SECTOR_DELETE_SUPERADMIN_ERROR   = "SECTOR_DELETE_SUPERADMIN_ERROR";

export const SECTOR_ALL_SUPERADMIN_LIST         = 'SECTOR_ALL_SUPERADMIN_LIST';
export const SECTOR_ALL_SUPERADMIN_LIST_SUCCESS = "SECTOR_ALL_SUPERADMIN_LIST_SUCCESS";
export const SECTOR_ALL_SUPERADMIN_LIST_ERROR   = "SECTOR_ALL_SUPERADMIN_LIST_ERROR";

export const SUBSECTOR_LIST_SUPERADMIN         = 'SUBSECTOR_LIST_SUPERADMIN';
export const SUBSECTOR_LIST_SUPERADMIN_SUCCESS = "SUBSECTOR_LIST_SUPERADMIN_SUCCESS";
export const SUBSECTOR_LIST_SUPERADMIN_ERROR   = "SUBSECTOR_LIST_SUPERADMIN_ERROR";

export const SUBSECTOR_ADD_SUPERADMIN    = 'SUBSECTOR_ADD_SUPERADMIN';
export const SUBSECTOR_ADD_SUPERADMIN_SUCCESS = "SUBSECTOR_ADD_SUPERADMIN_SUCCESS";
export const SUBSECTOR_ADD_SUPERADMIN_ERROR = "SUBSECTOR_ADD_SUPERADMIN_ERROR";

export const SUBSECTOR_EDIT_SUPERADMIN   = 'SUBSECTOR_EDIT_SUPERADMIN';
export const SUBSECTOR_EDIT_SUPERADMIN_SUCCESS = "SUBSECTOR_EDIT_SUPERADMIN_SUCCESS";
export const SUBSECTOR_EDIT_SUPERADMIN_ERROR = "SUBSECTOR_EDIT_SUPERADMIN_ERROR";

export const SUBSECTOR_UPDATE_SUPERADMIN   = 'SUBSECTOR_UPDATE_SUPERADMIN';
export const SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS = "SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS";
export const SUBSECTOR_UPDATE_SUPERADMIN_ERROR = "SUBSECTOR_UPDATE_SUPERADMIN_ERROR";

export const SUBSECTOR_DELETE_SUPERADMIN         = 'SUBSECTOR_DELETE_SUPERADMIN';
export const SUBSECTOR_DELETE_SUPERADMIN_SUCCESS = "SUBSECTOR_DELETE_SUPERADMIN_SUCCESS";
export const SUBSECTOR_DELETE_SUPERADMIN_ERROR   = "SUBSECTOR_DELETE_SUPERADMIN_ERROR";

export const SUBSECTOR_ALL_LIST_SUPERADMIN         = 'SUBSECTOR_ALL_LIST_SUPERADMIN';
export const SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS = "SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS";
export const SUBSECTOR_ALL_LIST_SUPERADMIN_ERROR   = "SUBSECTOR_ALL_LIST_SUPERADMIN_ERROR";


export const OTHER_EXP_LIST           = 'OTHER_EXP_LIST';
export const OTHER_EXP_LIST_SUCCESS   = "OTHER_EXP_LIST_SUCCESS";
export const OTHER_EXP_LIST_ERROR     = "OTHER_EXP_LIST_ERROR";

export const OTHER_EXP_ADD            = 'OTHER_EXP_ADD';
export const OTHER_EXP_ADD_SUCCESS    = "OTHER_EXP_ADD_SUCCESS";
export const OTHER_EXP_ADD_ERROR      = "OTHER_EXP_ADD_ERROR";

export const OTHER_EXP_EDIT           = 'OTHER_EXP_EDIT';
export const OTHER_EXP_EDIT_SUCCESS   = "OTHER_EXP_EDIT_SUCCESS";
export const OTHER_EXP_EDIT_ERROR     = "OTHER_EXP_EDIT_ERROR";

export const OTHER_EXP_UPDATE         = 'OTHER_EXP_UPDATE';
export const OTHER_EXP_UPDATE_SUCCESS = "OTHER_EXP_UPDATE_SUCCESS";
export const OTHER_EXP_UPDATE_ERROR   = "OTHER_EXP_UPDATE_ERROR";

export const OTHER_EXP_DELETE         = 'OTHER_EXP_DELETE';
export const OTHER_EXP_DELETE_SUCCESS = "OTHER_EXP_DELETE_SUCCESS";
export const OTHER_EXP_DELETE_ERROR   = "OTHER_EXP_DELETE_ERROR";

export const CLIENT_CATEGORY_LIST           = 'CLIENT_CATEGORY_LIST';
export const CLIENT_CATEGORY_LIST_SUCCESS   = "CLIENT_CATEGORY_LIST_SUCCESS";
export const CLIENT_CATEGORY_LIST_ERROR     = "CLIENT_CATEGORY_LIST_ERROR";

export const CLIENT_CATEGORY_ADD            = 'CLIENT_CATEGORY_ADD';
export const CLIENT_CATEGORY_ADD_SUCCESS    = "CLIENT_CATEGORY_ADD_SUCCESS";
export const CLIENT_CATEGORY_ADD_ERROR      = "CLIENT_CATEGORY_ADD_ERROR";

export const CLIENT_CATEGORY_EDIT           = 'CLIENT_CATEGORY_EDIT';
export const CLIENT_CATEGORY_EDIT_SUCCESS   = "CLIENT_CATEGORY_EDIT_SUCCESS";
export const CLIENT_CATEGORY_EDIT_ERROR     = "CLIENT_CATEGORY_EDIT_ERROR";

export const CLIENT_CATEGORY_UPDATE         = 'CLIENT_CATEGORY_UPDATE';
export const CLIENT_CATEGORY_UPDATE_SUCCESS = "CLIENT_CATEGORY_UPDATE_SUCCESS";
export const CLIENT_CATEGORY_UPDATE_ERROR   = "CLIENT_CATEGORY_UPDATE_ERROR";

export const CLIENT_CATEGORY_DELETE         = 'CLIENT_CATEGORY_DELETE';
export const CLIENT_CATEGORY_DELETE_SUCCESS = "CLIENT_CATEGORY_DELETE_SUCCESS";
export const CLIENT_CATEGORY_DELETE_ERROR   = "CLIENT_CATEGORY_DELETE_ERROR";

export const CLIENT_CATEGORY_MASTER_LIST           = 'CLIENT_CATEGORY_MASTER_LIST';
export const CLIENT_CATEGORY_MASTER_LIST_SUCCESS   = "CLIENT_CATEGORY_MASTER_LIST_SUCCESS";
export const CLIENT_CATEGORY_MASTER_LIST_ERROR     = "CLIENT_CATEGORY_MASTER_LIST_ERROR";

export const CLIENT_CATEGORY_MASTER_ADD            = 'CLIENT_CATEGORY_MASTER_ADD';
export const CLIENT_CATEGORY_MASTER_ADD_SUCCESS    = "CLIENT_CATEGORY_MASTER_ADD_SUCCESS";
export const CLIENT_CATEGORY_MASTER_ADD_ERROR      = "CLIENT_CATEGORY_MASTER_ADD_ERROR";

export const CLIENT_CATEGORY_MASTER_EDIT           = 'CLIENT_CATEGORY_MASTER_EDIT';
export const CLIENT_CATEGORY_MASTER_EDIT_SUCCESS   = "CLIENT_CATEGORY_MASTER_EDIT_SUCCESS";
export const CLIENT_CATEGORY_MASTER_EDIT_ERROR     = "CLIENT_CATEGORY_MASTER_EDIT_ERROR";

export const CLIENT_CATEGORY_MASTER_UPDATE         = 'CLIENT_CATEGORY_MASTER_UPDATE';
export const CLIENT_CATEGORY_MASTER_UPDATE_SUCCESS = "CLIENT_CATEGORY_MASTER_UPDATE_SUCCESS";
export const CLIENT_CATEGORY_MASTER_UPDATE_ERROR   = "CLIENT_CATEGORY_MASTER_UPDATE_ERROR";

export const CLIENT_CATEGORY_MASTER_DELETE         = 'CLIENT_CATEGORY_MASTER_DELETE';
export const CLIENT_CATEGORY_MASTER_DELETE_SUCCESS = "CLIENT_CATEGORY_MASTER_DELETE_SUCCESS";
export const CLIENT_CATEGORY_MASTER_DELETE_ERROR   = "CLIENT_CATEGORY_MASTER_DELETE_ERROR";

export const USER_DOC_MASTER_LIST           = 'USER_DOC_MASTER_LIST';
export const USER_DOC_MASTER_LIST_SUCCESS   = "USER_DOC_MASTER_LIST_SUCCESS";
export const USER_DOC_MASTER_LIST_ERROR     = "USER_DOC_MASTER_LIST_ERROR";

export const USER_DOC_LIST           = 'USER_DOC_LIST';
export const USER_DOC_LIST_SUCCESS   = "USER_DOC_LIST_SUCCESS";
export const USER_DOC_LIST_ERROR     = "USER_DOC_LIST_ERROR";

export const USER_DOC_ADD            = 'USER_DOC_ADD';
export const USER_DOC_ADD_SUCCESS    = "USER_DOC_ADD_SUCCESS";
export const USER_DOC_ADD_ERROR      = "USER_DOC_ADD_ERROR";

export const USER_DOC_EDIT           = 'USER_DOC_EDIT';
export const USER_DOC_EDIT_SUCCESS   = "USER_DOC_EDIT_SUCCESS";
export const USER_DOC_EDIT_ERROR     = "USER_DOC_EDIT_ERROR";

export const USER_DOC_UPDATE         = 'USER_DOC_UPDATE';
export const USER_DOC_UPDATE_SUCCESS = "USER_DOC_UPDATE_SUCCESS";
export const USER_DOC_UPDATE_ERROR   = "USER_DOC_UPDATE_ERROR";

export const USER_DOC_DELETE         = 'USER_DOC_DELETE';
export const USER_DOC_DELETE_SUCCESS = "USER_DOC_DELETE_SUCCESS";
export const USER_DOC_DELETE_ERROR   = "USER_DOC_DELETE_ERROR";

export const OMNU_POINTS_LIST               = 'OMNU_POINTS_LIST';
export const OMNU_POINTS_LIST_SUCCESS       = 'OMNU_POINTS_LIST_SUCCESS';
export const OMNU_POINTS_LIST_ERROR         = 'OMNU_POINTS_LIST_ERROR';

export const OMNU_POINTS_SAVE               = 'OMNU_POINTS_SAVE';
export const OMNU_POINTS_SAVE_SUCCESS       = 'OMNU_POINTS_SAVE_SUCCESS';
export const OMNU_POINTS_SAVE_ERROR         = 'OMNU_POINTS_SAVE_ERROR';


export const AFFILIATES_LIST           = 'AFFILIATES_LIST';
export const AFFILIATES_LIST_SUCCESS   = "AFFILIATES_LIST_SUCCESS";
export const AFFILIATES_LIST_ERROR     = "AFFILIATES_LIST_ERROR";

export const AFFILIATE_COMPANYINFO_ADD            = 'AFFILIATE_COMPANYINFO_ADD';
export const AFFILIATE_COMPANYINFO_ADD_SUCCESS    = "AFFILIATE_COMPANYINFO_ADD_SUCCESS";
export const AFFILIATE_COMPANYINFO_ADD_ERROR      = "AFFILIATE_COMPANYINFO_ADD_ERROR";

export const AFFILIATE_EDIT           = 'AFFILIATE_EDIT';
export const AFFILIATE_EDIT_SUCCESS   = "AFFILIATE_EDIT_SUCCESS";
export const AFFILIATE_EDIT_ERROR     = "AFFILIATE_EDIT_ERROR";

export const AFFILIATE_CMPNY_INFO_UPDATE         = 'AFFILIATE_CMPNY_INFO_UPDATE';
export const AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS = "AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS";
export const AFFILIATE_CMPNY_INFO_UPDATE_ERROR   = "AFFILIATE_CMPNY_INFO_UPDATE_ERROR";

export const AFFILIATE_ADDRESS_UPDATE         = 'AFFILIATE_ADDRESS_UPDATE';
export const AFFILIATE_ADDRESS_UPDATE_SUCCESS = "AFFILIATE_ADDRESS_UPDATE_SUCCESS";
export const AFFILIATE_ADDRESS_UPDATE_ERROR   = "AFFILIATE_ADDRESS_UPDATE_ERROR";

export const AFFILIATE_PRMRY_CNT_UPDATE         = 'AFFILIATE_PRMRY_CNT_UPDATE';
export const AFFILIATE_PRMRY_CNT_ADD_SUCCESS    = "AFFILIATE_PRMRY_CNT_ADD_SUCCESS";
export const AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS = "AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS";
export const AFFILIATE_PRMRY_CNT_UPDATE_ERROR   = "AFFILIATE_PRMRY_CNT_UPDATE_ERROR";

export const AFFILIATE_SETTINGS_UPDATE         = 'AFFILIATE_SETTINGS_UPDATE';
export const AFFILIATE_SETTINGS_UPDATE_SUCCESS = "AFFILIATE_SETTINGS_UPDATE_SUCCESS";
export const AFFILIATE_SETTINGS_UPDATE_ERROR   = "AFFILIATE_SETTINGS_UPDATE_ERROR";

export const AFFILIATE_DELETE         = 'AFFILIATE_DELETE';
export const AFFILIATE_DELETE_SUCCESS = "AFFILIATE_DELETE_SUCCESS";
export const AFFILIATE_DELETE_ERROR   = "AFFILIATE_DELETE_ERROR";

export const CLEAR = "CLEAR"; 

export const SKILL_LIST_AFFILIATE = 'SKILL_LIST_AFFILIATE';
export const SKILL_LIST_AFFILIATE_SUCCESS = 'SKILL_LIST_AFFILIATE_SUCCESS';
export const SKILL_LIST_AFFILIATE_ERROR = 'SKILL_LIST_AFFILIATE_ERROR';

export const SKILL_ADD_AFFILIATE = 'SKILL_ADD_AFFILIATE';
export const SKILL_ADD_AFFILIATE_SUCCESS = 'SKILL_ADD_AFFILIATE_SUCCESS';
export const SKILL_ADD_AFFILIATE_ERROR = 'SKILL_ADD_AFFILIATE_ERROR';

export const SKILL_EDIT_AFFILIATE = 'SKILL_EDIT_AFFILIATE';
export const SKILL_EDIT_AFFILIATE_SUCCESS = 'SKILL_EDIT_AFFILIATE_SUCCESS';
export const SKILL_EDIT_AFFILIATE_ERROR = 'SKILL_EDIT_AFFILIATE_ERROR';

export const SKILL_UPDATE_AFFILIATE = 'SKILL_UPDATE_AFFILIATE';
export const SKILL_UPDATE_AFFILIATE_SUCCESS = 'SKILL_UPDATE_AFFILIATE_SUCCESS';
export const SKILL_UPDATE_AFFILIATE_ERROR = 'SKILL_UPDATE_AFFILIATE_ERROR';

export const SKILL_DELETE_AFFILIATE = 'SKILL_DELETE_AFFILIATE';
export const SKILL_DELETE_AFFILIATE_SUCCESS = 'SKILL_DELETE_AFFILIATE_SUCCESS';
export const SKILL_DELETE_AFFILIATE_ERROR = 'SKILL_DELETE_AFFILIATE_ERROR';

export const MASTER_LOCATION_LIST = "MASTER_LOCATION_LIST";
export const MASTER_LOCATION_LIST_SUCCESS = "MASTER_LOCATION_LIST_SUCCESS";
export const MASTER_LOCATION_LIST_ERROR = "MASTER_LOCATION_LIST_ERROR";

export const LIST_CURRENCY = "LIST_CURRENCY";
export const LIST_CURRENCY_SUCCESS = "LIST_CURRENCY_SUCCESS";
export const LIST_CURRENCY_ERROR = "LIST_CURRENCY_ERROR";

export const FILTERBY_TOGGLE = "FILTERBY_TOGGLE"
export const MENU_DEACTIVE  = "MENU_DEACTIVE"
export const MENU_ACTIVE    = "MENU_ACTIVE"
export const FROM_DASHBOARD    = "FROM_DASHBOARD"
export const FROM_REPORT       = "FROM_REPORT"
export const FROM_DASHBOARD_SHIFT_TIME_CHANGE    = "FROM_DASHBOARD_SHIFT_TIME_CHANGE"
export const FROM_EXPIRY_CERTIFICATES    = "FROM_EXPIRY_CERTIFICATES"
export const FROM_CLIENT_DASHBOARD_QUOTES    = "FROM_CLIENT_DASHBOARD_QUOTES"
export const FROM_CLIENT_DASHBOARD_EVENTS    = "FROM_CLIENT_DASHBOARD_EVENTS"
export const FROM_CLIENT_DASHBOARD_COMPLETED_EVENTS    = "FROM_CLIENT_DASHBOARD_COMPLETED_EVENTS"
export const FROM_ACTION_REQUIRED     = "FROM_ACTION_REQUIRED"
export const SHIFT_TITLE    		  = "SHIFT_TITLE"
export const FEEDBACK_TITLE    		  = "FEEDBACK_TITLE"
export const TIMESHEET_DATE_HEADER    = "TIMESHEET_DATE_HEADER"
export const CREW_LIST_TITLE    	  = "CREW_LIST_TITLE"

export const APPAYRATE_LIST_AFFILIATE = 'APPAYRATE_LIST_AFFILIATE';
export const APPAYRATE_LIST_AFFILIATE_SUCCESS = 'APPAYRATE_LIST_AFFILIATE_SUCCESS';
export const APPAYRATE_LIST_AFFILIATE_ERROR = 'APPAYRATE_LIST_AFFILIATE_ERROR';

export const APPAYRATE_ADD_AFFILIATE = 'APPAYRATE_ADD_AFFILIATE';
export const APPAYRATE_ADD_AFFILIATE_SUCCESS = 'APPAYRATE_ADD_AFFILIATE_SUCCESS';
export const APPAYRATE_ADD_AFFILIATE_ERROR = 'APPAYRATE_ADD_AFFILIATE_ERROR';

export const APPAYRATE_UPDATE_AFFILIATE = 'APPAYRATE_UPDATE_AFFILIATE';
export const APPAYRATE_UPDATE_AFFILIATE_SUCCESS = 'APPAYRATE_UPDATE_AFFILIATE_SUCCESS';
export const APPAYRATE_UPDATE_AFFILIATE_ERROR = 'APPAYRATE_UPDATE_AFFILIATE_ERROR';

export const APPAYRATE_DELETE_AFFILIATE = 'APPAYRATE_DELETE_AFFILIATE';
export const APPAYRATE_DELETE_AFFILIATE_SUCCESS = 'APPAYRATE_DELETE_AFFILIATE_SUCCESS';
export const APPAYRATE_DELETE_AFFILIATE_ERROR = 'APPAYRATE_DELETE_AFFILIATE_ERROR';

export const LIST_PRMY_CNCT = "LIST_PRMY_CNCT";
export const LIST_PRMY_CNCT_SUCCESS = "LIST_PRMY_CNCT_SUCCESS";
export const LIST_PRMY_CNCT_ERROR = "LIST_PRMY_CNCT_ERROR";

export const SKILL_SEL_LIST_AFFILIATE = "SKILL_SEL_LIST_AFFILIATE";
export const SKILL_SEL_LIST_AFFILIATE_SUCCESS = "SKILL_SEL_LIST_AFFILIATE_SUCCESS";
export const SKILL_SEL_LIST_AFFILIATE_ERROR = "SKILL_SEL_LIST_AFFILIATE_ERROR"; 

export const STCBONUS_LIST_AFFILIATE = "STCBONUS_LIST_AFFILIATE";
export const STCBONUS_LIST_AFFILIATE_SUCCESS = "STCBONUS_LIST_AFFILIATE_SUCCESS";
export const STCBONUS_LIST_AFFILIATE_ERROR = "STCBONUS_LIST_AFFILIATE_ERROR";

export const STCBONUS_ADD_AFFILIATE = "STCBONUS_ADD_AFFILIATE";
export const STCBONUS_ADD_AFFILIATE_SUCCESS = "STCBONUS_ADD_AFFILIATE_SUCCESS";
export const STCBONUS_ADD_AFFILIATE_ERROR = "STCBONUS_ADD_AFFILIATE_ERROR";

export const STCBONUS_UPDATE_AFFILIATE = "STCBONUS_UPDATE_AFFILIATE";
export const STCBONUS_UPDATE_AFFILIATE_SUCCESS = "STCBONUS_UPDATE_AFFILIATE_SUCCESS";
export const STCBONUS_UPDATE_AFFILIATE_ERROR = "STCBONUS_UPDATE_AFFILIATE_ERROR"; 

export const STCBONUS_DELETE_AFFILIATE = "STCBONUS_DELETE_AFFILIATE";
export const STCBONUS_DELETE_AFFILIATE_SUCCESS = "STCBONUS_DELETE_AFFILIATE_SUCCESS";
export const STCBONUS_DELETE_AFFILIATE_ERROR = "STCBONUS_DELETE_AFFILIATE_ERROR";

export const KEY_LOCATION_LIST = "KEY_LOCATION_LIST";
export const KEY_LOCATION_LIST_SUCCESS = "KEY_LOCATION_LIST_SUCCESS";
export const KEY_LOCATION_LIST_ERROR = "KEY_LOCATION_LIST_ERROR";

export const KEY_LOCATION_ADD = "KEY_LOCATION_ADD";
export const KEY_LOCATION_ADD_SUCCESS = "KEY_LOCATION_ADD_SUCCESS";
export const KEY_LOCATION_ADD_ERROR = "KEY_LOCATION_ADD_ERROR";

export const KEY_LOCATION_VIEW = "KEY_LOCATION_VIEW";
export const KEY_LOCATION_VIEW_SUCCESS = "KEY_LOCATION_VIEW_SUCCESS";
export const KEY_LOCATION_VIEW_ERROR = "KEY_LOCATION_VIEW_ERROR";

export const KEY_LOCATION_DELETE = "KEY_LOCATION_DELETE";
export const KEY_LOCATION_DELETE_SUCCESS = "KEY_LOCATION_DELETE_SUCCESS";
export const KEY_LOCATION_DELETE_ERROR = "KEY_LOCATION_DELETE_ERROR";

export const EVENT_LOCATION_LIST = "EVENT_LOCATION_LIST";
export const EVENT_LOCATION_LIST_SUCCESS = "EVENT_LOCATION_LIST_SUCCESS";
export const EVENT_LOCATION_LIST_ERROR = "EVENT_LOCATION_LIST_ERROR";

export const EVENT_LOCATION_ADD = "EVENT_LOCATION_ADD";
export const EVENT_LOCATION_ADD_SUCCESS = "EVENT_LOCATION_ADD_SUCCESS";
export const EVENT_LOCATION_ADD_ERROR = "EVENT_LOCATION_ADD_ERROR";

export const EVENT_LOCATION_VIEW = "EVENT_LOCATION_VIEW";
export const EVENT_LOCATION_VIEW_SUCCESS = "EVENT_LOCATION_VIEW_SUCCESS";
export const EVENT_LOCATION_VIEW_ERROR = "EVENT_LOCATION_VIEW_ERROR";

export const EVENT_LOCATION_DELETE = "EVENT_LOCATION_DELETE";
export const EVENT_LOCATION_DELETE_SUCCESS = "EVENT_LOCATION_DELETE_SUCCESS";
export const EVENT_LOCATION_DELETE_ERROR = "EVENT_LOCATION_DELETE_ERROR";

export const KEY_LOC_LIST_AFFILIATE             = "KEY_LOC_LIST_AFFILIATE";
export const KEY_LOC_LIST_AFFILIATE_SUCCESS     = "KEY_LOC_LIST_AFFILIATE_SUCCESS";
export const KEY_LOC_LIST_AFFILIATE_ERROR       = "KEY_LOC_LIST_AFFILIATE_ERROR";

// export const GOOGLE_LOCATION_SEARCH = "GOOGLE_LOCATION_SEARCH";

export const DEPARTMENT_LIST_AFFILIATE          = "DEPARTMENT_LIST_AFFILIATE";
export const DEPARTMENT_LIST_AFFILIATE_SUCCESS  = "DEPARTMENT_LIST_AFFILIATE_SUCCESS";
export const DEPARTMENT_LIST_AFFILIATE_ERROR    = "DEPARTMENT_LIST_AFFILIATE_ERROR";

export const DEPARTMENT_ADD_AFFILIATE           = "DEPARTMENT_ADD_AFFILIATE";
export const DEPARTMENT_ADD_AFFILIATE_SUCCESS   = "DEPARTMENT_ADD_AFFILIATE_SUCCESS";
export const DEPARTMENT_ADD_AFFILIATE_ERROR     = "DEPARTMENT_ADD_AFFILIATE_ERROR";

export const DEPARTMENT_UPDATE_AFFILIATE        = "DEPARTMENT_UPDATE_AFFILIATE";
export const DEPARTMENT_UPDATE_AFFILIATE_SUCCESS= "DEPARTMENT_UPDATE_AFFILIATE_SUCCESS";
export const DEPARTMENT_UPDATE_AFFILIATE_ERROR  = "DEPARTMENT_UPDATE_AFFILIATE_ERROR";

export const DEPARTMENT_DELETE_AFFILIATE        = "DEPARTMENT_DELETE_AFFILIATE";
export const DEPARTMENT_DELETE_AFFILIATE_SUCCESS= "DEPARTMENT_DELETE_AFFILIATE_SUCCESS";
export const DEPARTMENT_DELETE_AFFILIATE_ERROR  = "DEPARTMENT_DELETE_AFFILIATE_ERROR";

export const EVENT_LOCATION_IMPORT = "EVENT_LOCATION_IMPORT";
export const EVENT_LOCATION_IMPORT_SUCCESS = "EVENT_LOCATION_IMPORT_SUCCESS";
export const EVENT_LOCATION_IMPORT_ERROR = "EVENT_LOCATION_IMPORT_ERROR";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const MASTER_RATE_CARD_LIST_AFFILIATE          = "MASTER_RATE_CARD_LIST_AFFILIATE";
export const MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS  = "MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS";
export const MASTER_RATE_CARD_LIST_AFFILIATE_ERROR    = "MASTER_RATE_CARD_LIST_AFFILIATE_ERROR";

export const MASTER_RATE_CARD_UPDATE_AFFILIATE        = "MASTER_RATE_CARD_UPDATE_AFFILIATE";
export const MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS= "MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS";
export const MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR  = "MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR";

export const CLIENT_LIST             = "CLIENT_LIST";
export const CLIENT_LIST_SUCCESS     = "CLIENT_LIST_SUCCESS";
export const CLIENT_LIST_ERROR       = "CLIENT_LIST_ERROR";

export const CLIENT_FULL_LIST             = "CLIENT_FULL_LIST";
export const CLIENT_FULL_LIST_SUCCESS     = "CLIENT_FULL_LIST_SUCCESS";
export const CLIENT_FULL_LIST_ERROR       = "CLIENT_FULL_LIST_ERROR";

export const CLIENT_QUICK_ADD             = "CLIENT_QUICK_ADD";
export const CLIENT_QUICK_ADD_SUCCESS     = "CLIENT_QUICK_ADD_SUCCESS";
export const CLIENT_QUICK_ADD_ERROR       = "CLIENT_QUICK_ADD_ERROR";

export const CLIENT_CMPNY_INFO_ADD          = "CLIENT_CMPNY_INFO_ADD";
export const CLIENT_CMPNY_INFO_ADD_SUCCESS  = "CLIENT_CMPNY_INFO_ADD_SUCCESS";
export const CLIENT_CMPNY_INFO_ADD_ERROR    = "CLIENT_CMPNY_INFO_ADD_ERROR";

export const CLIENT_PRMRY_CNCT_ADD          = "CLIENT_PRMRY_CNCT_ADD";
export const CLIENT_PRMRY_CNCT_ADD_SUCCESS  = "CLIENT_PRMRY_CNCT_ADD_SUCCESS";
export const CLIENT_PRMRY_CNCT_ADD_ERROR    = "CLIENT_PRMRY_CNCT_ADD_ERROR";

export const CLIENT_CMPNY_INFO_UPDATE          = "CLIENT_CMPNY_INFO_UPDATE";
export const CLIENT_CMPNY_INFO_UPDATE_SUCCESS  = "CLIENT_CMPNY_INFO_UPDATE_SUCCESS";
export const CLIENT_CMPNY_INFO_UPDATE_ERROR    = "CLIENT_CMPNY_INFO_UPDATE_ERROR";

export const CLIENT_PRMRY_CNCT_UPDATE          = "CLIENT_PRMRY_CNCT_UPDATE";
export const CLIENT_PRMRY_CNCT_UPDATE_SUCCESS  = "CLIENT_PRMRY_CNCT_UPDATE_SUCCESS";
export const CLIENT_PRMRY_CNCT_UPDATE_ERROR    = "CLIENT_PRMRY_CNCT_UPDATE_ERROR";

export const CLIENT_EDIT               = "CLIENT_EDIT";
export const CLIENT_EDIT_SUCCESS       = "CLIENT_EDIT_SUCCESS";
export const CLIENT_EDIT_ERROR         = "CLIENT_EDIT_ERROR";

export const CLIENT_ACTIVE_DEACTIVE             = "CLIENT_ACTIVE_DEACTIVE"
export const CLIENT_ACTIVE_DEACTIVE_SUCCESS     = "CLIENT_ACTIVE_DEACTIVE_SUCCESS";
export const CLIENT_ACTIVE_DEACTIVE_ERROR       = "CLIENT_ACTIVE_DEACTIVE_ERROR";

export const CLIENT_CONTACT_LIST             = "CLIENT_CONTACT_LIST"
export const CLIENT_CONTACT_LIST_SUCCESS     = "CLIENT_CONTACT_LIST_SUCCESS";
export const CLIENT_CONTACT_LIST_ERROR       = "CLIENT_CONTACT_LIST_ERROR";

export const CLIENT_CONTACT_ADD             = "CLIENT_CONTACT_ADD"
export const CLIENT_CONTACT_ADD_SUCCESS     = "CLIENT_CONTACT_ADD_SUCCESS";
export const CLIENT_CONTACT_ADD_ERROR       = "CLIENT_CONTACT_ADD_ERROR";

export const ASS_USER_ADD             = "ASS_USER_ADD"
export const ASS_USER_ADD_SUCCESS     = "ASS_USER_ADD_SUCCESS";
export const ASS_USER_ADD_ERROR       = "ASS_USER_ADD_ERROR";

export const ASS_USER_EDIT             = "ASS_USER_EDIT"
export const ASS_USER_EDIT_SUCCESS     = "ASS_USER_EDIT_SUCCESS";
export const ASS_USER_EDIT_ERROR       = "ASS_USER_EDIT_ERROR";

export const ASS_USER_UPDATE             = "ASS_USER_UPDATE"
export const ASS_USER_UPDATE_SUCCESS     = "ASS_USER_UPDATE_SUCCESS";
export const ASS_USER_UPDATE_ERROR       = "ASS_USER_UPDATE_ERROR";

export const ASS_USER_DELETE             = "ASS_USER_DELETE"
export const ASS_USER_DELETE_SUCCESS     = "ASS_USER_DELETE_SUCCESS";
export const ASS_USER_DELETE_ERROR       = "ASS_USER_DELETE_ERROR";

export const ASS_USER_ACTIVATE             = "ASS_USER_ACTIVATE"
export const ASS_USER_ACTIVATE_SUCCESS     = "ASS_USER_ACTIVATE_SUCCESS";
export const ASS_USER_ACTIVATE_ERROR       = "ASS_USER_ACTIVATE_ERROR";

export const ASSOCIATE_USER_DELETE         = "ASSOCIATE_USER_DELETE"
export const ASSOCIATE_USER_DELETE_SUCCESS = "ASSOCIATE_USER_DELETE_SUCCESS";
export const ASSOCIATE_USER_DELETE_ERROR   = "ASSOCIATE_USER_DELETE_ERROR";


export const ASS_USER_LIST           = 'ASS_USER_LIST';
export const ASS_USER_LIST_SUCCESS   = 'ASS_USER_LIST_SUCCESS';
export const ASS_USER_LIST_ERROR     = 'ASS_USER_LIST_ERROR'; 

export const CREW_LIST               = "CREW_LIST";
export const CREW_LIST_SUCCESS       = "CREW_LIST_SUCCESS";
export const CREW_LIST_ERROR         = "CREW_LIST_ERROR";

export const CREW_ALL_LIST               = "CREW_ALL_LIST";
export const CREW_ALL_LIST_SUCCESS       = "CREW_ALL_LIST_SUCCESS";
export const CREW_ALL_LIST_ERROR         = "CREW_ALL_LIST_ERROR";

export const CREW_BASIC_INFO_ADD               = "CREW_BASIC_INFO_ADD";
export const CREW_BASIC_INFO_ADD_SUCCESS       = "CREW_BASIC_INFO_ADD_SUCCESS";
export const CREW_BASIC_INFO_ADD_ERROR         = "CREW_BASIC_INFO_ADD_ERROR";

export const CREW_BASIC_INFO_UPDATE               = "CREW_BASIC_INFO_UPDATE";
export const CREW_BASIC_INFO_UPDATE_SUCCESS       = "CREW_BASIC_INFO_UPDATE_SUCCESS";
export const CREW_BASIC_INFO_UPDATE_ERROR         = "CREW_BASIC_INFO_UPDATE_ERROR";

export const CREW_EDIT               = "CREW_EDIT";
export const CREW_EDIT_SUCCESS       = "CREW_EDIT_SUCCESS";
export const CREW_EDIT_ERROR         = "CREW_EDIT_ERROR";

export const CREW_AVAILABILITY              = "CREW_AVAILABILITY"
export const CREW_AVAILABILITY_SUCCESS      = "CREW_AVAILABILITY_SUCCESS";
export const CREW_AVAILABILITY_ERROR        = "CREW_AVAILABILITY_ERROR";

export const CREW_APPROVE              = "CREW_APPROVE"
export const CREW_APPROVE_SUCCESS      = "CREW_APPROVE_SUCCESS";
export const CREW_APPROVE_ERROR        = "CREW_APPROVE_ERROR";

export const CREW_INDUCTION              = "CREW_INDUCTION"
export const CREW_INDUCTION_SUCCESS      = "CREW_INDUCTION_SUCCESS";
export const CREW_INDUCTION_ERROR        = "CREW_INDUCTION_ERROR";

export const CREW_ACTIVE_DEACTIVE              = "CREW_ACTIVE_DEACTIVE"
export const CREW_ACTIVE_DEACTIVE_SUCCESS      = "CREW_ACTIVE_DEACTIVE_SUCCESS";
export const CREW_ACTIVE_DEACTIVE_ERROR        = "CREW_ACTIVE_DEACTIVE_ERROR";

export const CREW_CHIEF_APPROVE              = "CREW_CHIEF_APPROVE"
export const CREW_CHIEF_APPROVE_SUCCESS      = "CREW_CHIEF_APPROVE_SUCCESS";
export const CREW_CHIEF_APPROVE_ERROR        = "CREW_CHIEF_APPROVE_ERROR";

export const CREW_SKILL_LIST              = "CREW_SKILL_LIST"
export const CREW_SKILL_LIST_SUCCESS      = "CREW_SKILL_LIST_SUCCESS";
export const CREW_SKILL_LIST_ERROR        = "CREW_SKILL_LIST_ERROR";

export const CREW_SKILL_SAVE              = "CREW_SKILL_SAVE"
export const CREW_SKILL_SAVE_SUCCESS      = "CREW_SKILL_SAVE_SUCCESS";
export const CREW_SKILL_SAVE_ERROR        = "CREW_SKILL_SAVE_ERROR";

export const CREW_AFFILIATE_SKILL_LIST              = "CREW_AFFILIATE_SKILL_LIST"
export const CREW_AFFILIATE_SKILL_LIST_SUCCESS      = "CREW_AFFILIATE_SKILL_LIST_SUCCESS";
export const CREW_AFFILIATE_SKILL_LIST_ERROR        = "CREW_AFFILIATE_SKILL_LIST_ERROR";

export const CREW_IMPORT                  = "CREW_IMPORT";
export const CREW_IMPORT_SUCCESS          = "CREW_IMPORT_SUCCESS";
export const CREW_IMPORT_ERROR            = "CREW_IMPORT_ERROR";

export const DYNAMIC_FIELDS_MASTER_LIST          = "DYNAMIC_FIELDS_MASTER_LIST";
export const DYNAMIC_FIELDS_MASTER_LIST_SUCCESS  = "DYNAMIC_FIELDS_MASTER_LIST_SUCCESS";
export const DYNAMIC_FIELDS_MASTER_LIST_ERROR    = "DYNAMIC_FIELDS_MASTER_LIST_ERROR";

export const DYNAMIC_FIELDS_LIST          = "DYNAMIC_FIELDS_LIST";
export const DYNAMIC_FIELDS_LIST_SUCCESS  = "DYNAMIC_FIELDS_LIST_SUCCESS";
export const DYNAMIC_FIELDS_LIST_ERROR    = "DYNAMIC_FIELDS_LIST_ERROR";

export const DYNAMIC_FIELDS_UPDATE        = "DYNAMIC_FIELDS_UPDATE";
export const DYNAMIC_FIELDS_UPDATE_SUCCESS= "DYNAMIC_FIELDS_UPDATE_SUCCESS";
export const DYNAMIC_FIELDS_UPDATE_ERROR  = "DYNAMIC_FIELDS_UPDATE_ERROR";

export const CLIENT_RATE_CARD_LIST        = "CLIENT_RATE_CARD_LIST"; 
export const CLIENT_RATE_CARD_LIST_SUCCESS= "CLIENT_RATE_CARD_LIST_SUCCESS"; 
export const CLIENT_RATE_CARD_LIST_ERROR  = "CLIENT_RATE_CARD_LIST_ERROR"; 

export const CLIENT_RATE_CARD_UPDATE        = "CLIENT_RATE_CARD_UPDATE";  
export const CLIENT_RATE_CARD_UPDATE_SUCCESS= "CLIENT_RATE_CARD_UPDATE_SUCCESS";  
export const CLIENT_RATE_CARD_UPDATE_ERROR  = "CLIENT_RATE_CARD_UPDATE_ERROR";  

export const ACTIVITY_LOG_LIST        = "ACTIVITY_LOG_LIST";  
export const ACTIVITY_LOG_LIST_SUCCESS= "ACTIVITY_LOG_LIST_SUCCESS";  
export const ACTIVITY_LOG_LIST_ERROR  = "ACTIVITY_LOG_LIST_ERROR";  

export const RESEND_EMAIL         = "RESEND_EMAIL";
export const RESEND_EMAIL_SUCCESS = "RESEND_EMAIL_SUCCESS";
export const RESEND_EMAIL_ERROR   = "RESEND_EMAIL_ERROR";

export const DYNAMIC_FIELDS_DATA_SAVE        = "DYNAMIC_FIELDS_DATA_SAVE";
export const DYNAMIC_FIELDS_DATA_SAVE_SUCCESS= "DYNAMIC_FIELDS_DATA_SAVE_SUCCESS";
export const DYNAMIC_FIELDS_DATA_SAVE_ERROR  = "DYNAMIC_FIELDS_DATA_SAVE_ERROR";

export const PROFILE_ROLE        = "PROFILE_ROLE";
export const PROFILE_ROLE_SUCCESS= "PROFILE_ROLE_SUCCESS";
export const PROFILE_ROLE_ERROR  = "PROFILE_ROLE_ERROR";


export const DOCUMENT_LIST        = "DOCUMENT_LIST";
export const DOCUMENT_LIST_SUCCESS= "DOCUMENT_LIST_SUCCESS";
export const DOCUMENT_LIST_ERROR  = "DOCUMENT_LIST_ERROR";

export const DOCUMENT_ADD        = "DOCUMENT_ADD";
export const DOCUMENT_ADD_SUCCESS= "DOCUMENT_ADD_SUCCESS";
export const DOCUMENT_ADD_ERROR  = "DOCUMENT_ADD_ERROR";

export const DOCUMENT_EDIT         = "DOCUMENT_EDIT";
export const DOCUMENT_EDIT_SUCCESS = "DOCUMENT_EDIT_SUCCESS";
export const DOCUMENT_EDIT_ERROR   = "DOCUMENT_EDIT_ERROR";

export const DOCUMENT_UPDATE        = "DOCUMENT_UPDATE";
export const DOCUMENT_UPDATE_SUCCESS= "DOCUMENT_UPDATE_SUCCESS";
export const DOCUMENT_UPDATE_ERROR  = "DOCUMENT_UPDATE_ERROR";

export const DOCUMENT_DELETE        = "DOCUMENT_DELETE";
export const DOCUMENT_DELETE_SUCCESS= "DOCUMENT_DELETE_SUCCESS";
export const DOCUMENT_DELETE_ERROR  = "DOCUMENT_DELETE_ERROR";

export const DOCUMENT_FILE_SAVE        = "DOCUMENT_FILE_SAVE";
export const DOCUMENT_FILE_SAVE_SUCCESS= "DOCUMENT_FILE_SAVE_SUCCESS";
export const DOCUMENT_FILE_SAVE_ERROR  = "DOCUMENT_FILE_SAVE_ERROR";

export const DOCUMENT_FILE_DELETE        = "DOCUMENT_FILE_DELETE";
export const DOCUMENT_FILE_DELETE_SUCCESS= "DOCUMENT_FILE_DELETE_SUCCESS";
export const DOCUMENT_FILE_DELETE_ERROR  = "DOCUMENT_FILE_DELETE_ERROR";

export const DOCUMENT_SKILL_LIST        = "DOCUMENT_SKILL_LIST";
export const DOCUMENT_SKILL_LIST_SUCCESS= "DOCUMENT_SKILL_LIST_SUCCESS";
export const DOCUMENT_SKILL_LIST_ERROR  = "DOCUMENT_SKILL_LIST_ERROR";

export const DEPARTMENT_LIST_ASSOC_USER          = "DEPARTMENT_LIST_ASSOC_USER";
export const DEPARTMENT_LIST_ASSOC_USER_SUCCESS  = "DEPARTMENT_LIST_ASSOC_USER_SUCCESS";
export const DEPARTMENT_LIST_ASSOC_USER_ERROR    = "DEPARTMENT_LIST_ASSOC_USER_ERROR";

export const ROLES_LIST_ASSOC_USER              = 'ROLES_LIST_ASSOC_USER';
export const ROLES_LIST_ASSOC_USER_SUCCESS      = 'ROLES_LIST_ASSOC_USER_SUCCESS';
export const ROLES_LIST_ASSOC_USER_ERROR        = 'ROLES_LIST_ASSOC_USER_ERROR'; 

export const QUOTES_LIST            = "QUOTES_LIST";
export const QUOTES_LIST_SUCCESS    = "QUOTES_LIST_SUCCESS";
export const QUOTES_LIST_ERROR      = "QUOTES_LIST_ERROR";

export const EVENT_LIST            = "EVENT_LIST";
export const EVENT_LIST_SUCCESS    = "EVENT_LIST_SUCCESS";
export const EVENT_LIST_ERROR      = "EVENT_LIST_ERROR";

export const QUOTE_CLIENT_LIST             = "QUOTE_CLIENT_LIST";
export const QUOTE_CLIENT_LIST_SUCCESS     = "QUOTE_CLIENT_LIST_SUCCESS";
export const QUOTE_CLIENT_LIST_ERROR       = "QUOTE_CLIENT_LIST_ERROR";

export const QUOTE_EVENT_LOCATION_LIST             = "QUOTE_EVENT_LOCATION_LIST";
export const QUOTE_EVENT_LOCATION_LIST_SUCCESS     = "QUOTE_EVENT_LOCATION_LIST_SUCCESS";
export const QUOTE_EVENT_LOCATION_LIST_ERROR       = "QUOTE_EVENT_LOCATION_LIST_ERROR";

export const EVENT_ADD             = "EVENT_ADD";
export const EVENT_ADD_SUCCESS     = "EVENT_ADD_SUCCESS";
export const EVENT_ADD_ERROR       = "EVENT_ADD_ERROR";

export const EVENT_EDIT            = "EVENT_EDIT";
export const EVENT_EDIT_SUCCESS     = "EVENT_EDIT_SUCCESS";
export const EVENT_EDIT_ERROR       = "EVENT_EDIT_ERROR";

export const EVENT_UPDATE             = "EVENT_UPDATE";
export const EVENT_UPDATE_SUCCESS     = "EVENT_UPDATE_SUCCESS";
export const EVENT_UPDATE_ERROR       = "EVENT_UPDATE_ERROR";

export const QUOTE_ACCEPT             = "QUOTE_ACCEPT";
export const QUOTE_ACCEPT_SUCCESS     = "QUOTE_ACCEPT_SUCCESS";
export const QUOTE_ACCEPT_ERROR       = "QUOTE_ACCEPT_ERROR";

export const QUOTE_REJECT             = "QUOTE_REJECT";
export const QUOTE_REJECT_SUCCESS     = "QUOTE_REJECT_SUCCESS";
export const QUOTE_REJECT_ERROR       = "QUOTE_REJECT_ERROR";

export const EVENT_DELETE             = "EVENT_DELETE";
export const EVENT_DELETE_SUCCESS     = "EVENT_DELETE_SUCCESS";
export const EVENT_DELETE_ERROR       = "EVENT_DELETE_ERROR";

export const EVENT_CANCEL            = "EVENT_CANCEL";
export const EVENT_CANCEL_SUCCESS     = "EVENT_CANCEL_SUCCESS";
export const EVENT_CANCEL_ERROR       = "EVENT_CANCEL_ERROR";

export const QUOTE_ASS_USER_LIST = "QUOTE_ASS_USER_LIST";
export const QUOTE_ASS_USER_LIST_SUCCESS = "QUOTE_ASS_USER_LIST_SUCCESS";
export const QUOTE_ASS_USER_LIST_ERROR = "QUOTE_ASS_USER_LIST_ERROR";

export const SHIFT_INDIVIDUAL_DETAILS = "SHIFT_INDIVIDUAL_DETAILS";
export const SHIFT_INDIVIDUAL_DETAILS_SUCCESS = "SHIFT_INDIVIDUAL_DETAILS_SUCCESS";
export const SHIFT_INDIVIDUAL_DETAILS_ERROR = "SHIFT_INDIVIDUAL_DETAILS_ERROR";

export const SHIFT_ADD = "SHIFT_ADD"; 
export const SHIFT_ADD_SUCCESS = "SHIFT_ADD_SUCCESS";
export const SHIFT_ADD_ERROR = "SHIFT_ADD_ERROR";

export const EVENT_CLIENT_DETAILS = "EVENT_CLIENT_DETAILS";
export const EVENT_CLIENT_DETAILS_SUCCESS = "EVENT_CLIENT_DETAILS_SUCCESS";
export const EVENT_CLIENT_DETAILS_ERROR = "EVENT_CLIENT_DETAILS_ERROR";

export const GENERATE_INVOICE = "GENERATE_INVOICE";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";
export const GENERATE_INVOICE_ERROR = "GENERATE_INVOICE_ERROR";

export const EVENT_AFFILIATE_DETAILS = "EVENT_AFFILIATE_DETAILS";
export const EVENT_AFFILIATE_DETAILS_SUCCESS = "EVENT_AFFILIATE_DETAILS_SUCCESS";
export const EVENT_AFFILIATE_DETAILS_ERROR = "EVENT_AFFILIATE_DETAILS_ERROR";

export const EVENT_QUOTE_SUMMARY = "EVENT_QUOTE_SUMMARY";
export const EVENT_QUOTE_SUMMARY_SUCCESS = "EVENT_QUOTE_SUMMARY_SUCCESS";
export const EVENT_QUOTE_SUMMARY_ERROR = "EVENT_QUOTE_SUMMARY_ERROR";

export const EVENT_QUOTE_PREVIEW = "EVENT_QUOTE_PREVIEW";
export const EVENT_QUOTE_PREVIEW_SUCCESS = "EVENT_QUOTE_PREVIEW_SUCCESS";
export const EVENT_QUOTE_PREVIEW_ERROR = "EVENT_QUOTE_PREVIEW_ERROR";

export const EVENT_SUMMARY = "EVENT_SUMMARY";
export const EVENT_SUMMARY_SUCCESS = "EVENT_SUMMARY_SUCCESS";
export const EVENT_SUMMARY_ERROR = "EVENT_SUMMARY_ERROR";

export const EVENT_CREW_CHIEF_COUNT = "EVENT_CREW_CHIEF_COUNT";
export const EVENT_CREW_CHIEF_COUNT_SUCCESS = "EVENT_CREW_CHIEF_COUNT_SUCCESS";
export const EVENT_CREW_CHIEF_COUNT_ERROR = "EVENT_CREW_CHIEF_COUNT_ERROR";

export const FCM_NOTIFI_TOKEN_SAVE          = "FCM_NOTIFI_TOKEN_SAVE";
export const FCM_NOTIFI_TOKEN_SAVE_SUCCESS  = "FCM_NOTIFI_TOKEN_SAVE_SUCCESS";
export const FCM_NOTIFI_TOKEN_SAVE_ERROR    = "FCM_NOTIFI_TOKEN_SAVE_ERROR";

export const FCM_NOTIFICATION_SEND          = "FCM_NOTIFICATION_SEND";
export const FCM_NOTIFICATION_SEND_SUCCESS  = "FCM_NOTIFICATION_SEND_SUCCESS";
export const FCM_NOTIFICATION_SEND_ERROR    = "FCM_NOTIFICATION_SEND_ERROR";

export const QUOTE_SEND_CLIENT = "QUOTE_SEND_CLIENT";
export const QUOTE_SEND_CLIENT_SUCCESS = "QUOTE_SEND_CLIENT_SUCCESS";
export const QUOTE_SEND_CLIENT_ERROR = "QUOTE_SEND_CLIENT_ERROR";

export const INVOICE_SEND_CLIENT = "INVOICE_SEND_CLIENT";
export const INVOICE_SEND_CLIENT_SUCCESS = "INVOICE_SEND_CLIENT_SUCCESS";
export const INVOICE_SEND_CLIENT_ERROR = "INVOICE_SEND_CLIENT_ERROR";

export const QUOTE_USER_ACTION_LOG = "QUOTE_USER_ACTION_LOG";
export const QUOTE_USER_ACTION_LOG_SUCCESS = "QUOTE_USER_ACTION_LOG_SUCCESS";
export const QUOTE_USER_ACTION_LOG_ERROR = "QUOTE_USER_ACTION_LOG_ERROR";

export const SHIFT_LIST = "SHIFT_LIST";
export const SHIFT_LIST_SUCCESS = "SHIFT_LIST_SUCCESS";
export const SHIFT_LIST_ERROR = "SHIFT_LIST_ERROR";

export const SHIFT_CANCEL            = "SHIFT_CANCEL";
export const SHIFT_CANCEL_SUCCESS     = "SHIFT_CANCEL_SUCCESS";
export const SHIFT_CANCEL_ERROR       = "SHIFT_CANCEL_ERROR";

export const SHIFT_QUICK_UPDATE = "SHIFT_QUICK_UPDATE";
export const SHIFT_QUICK_UPDATE_SUCCESS = "SHIFT_QUICK_UPDATE_SUCCESS";
export const SHIFT_QUICK_UPDATE_ERROR = "SHIFT_QUICK_UPDATE_ERROR";

export const QUOTE_DOWNLOAD         = "QUOTE_DOWNLOAD";
export const QUOTE_DOWNLOAD_SUCCESS = "QUOTE_DOWNLOAD_SUCCESS";
export const QUOTE_DOWNLOAD_ERROR   = "QUOTE_DOWNLOAD_ERROR";

export const INVOICE_DOWNLOAD           = "INVOICE_DOWNLOAD";
export const INVOICE_DOWNLOAD_SUCCESS   = "INVOICE_DOWNLOAD_SUCCESS";
export const INVOICE_DOWNLOAD_ERROR     = "INVOICE_DOWNLOAD_ERROR";

export const EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD           = "EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD";
export const EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS   = "EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS";
export const EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR     = "EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR";

export const EVENT_SHIFT_UPDATE = "EVENT_SHIFT_UPDATE";
export const EVENT_SHIFT_UPDATE_SUCCESS = "EVENT_SHIFT_UPDATE_SUCCESS";
export const EVENT_SHIFT_UPDATE_ERROR = "EVENT_SHIFT_UPDATE_ERROR";

export const EVENT_CLIENT_AFFILIATE_LIST = "EVENT_CLIENT_AFFILIATE_LIST";
export const EVENT_CLIENT_AFFILIATE_LIST_SUCCESS = "EVENT_CLIENT_AFFILIATE_LIST_SUCCESS";
export const EVENT_CLIENT_AFFILIATE_LIST_ERROR = "EVENT_CLIENT_AFFILIATE_LIST_ERROR";

export const SHIFT_DELETE = "SHIFT_DELETE";
export const SHIFT_DELETE_SUCCESS = "SHIFT_DELETE_SUCCESS";
export const SHIFT_DELETE_ERROR = "SHIFT_DELETE_ERROR";

export const SHIFT_EDIT = "SHIFT_EDIT"; 
export const SHIFT_EDIT_SUCCESS = "SHIFT_EDIT_SUCCESS";
export const SHIFT_EDIT_ERROR = "SHIFT_EDIT_ERROR";

export const SHIFT_GET_DETAILS = "SHIFT_GET_DETAILS"; 
export const SHIFT_GET_DETAILS_SUCCESS = "SHIFT_GET_DETAILS_SUCCESS";
export const SHIFT_GET_DETAILS_ERROR = "SHIFT_GET_DETAILS_ERROR";

export const QUOTE_REQUEST = "QUOTE_REQUEST";
export const QUOTE_REQUEST_SUCCESS = "QUOTE_REQUEST_SUCCESS";
export const QUOTE_REQUEST_ERROR = "QUOTE_REQUEST_ERROR";

export const COUNTRY_LIST = "COUNTRY_LIST";
export const COUNTRY_LIST_SUCCESS = "COUNTRY_LIST_SUCCESS";
export const COUNTRY_LIST_ERROR = "COUNTRY_LIST_ERROR";

export const EVENTS_CALENDAR_LIST = "EVENTS_CALENDAR_LIST";
export const EVENTS_CALENDAR_LIST_SUCCESS = "EVENTS_CALENDAR_LIST_SUCCESS";
export const EVENTS_CALENDAR_LIST_ERROR = "EVENTS_CALENDAR_LIST_ERROR";

export const SHIFT_SUMMARY = "SHIFT_SUMMARY "; // FOR SLIDER, FROM SHIFT LISTING 
export const SHIFT_SUMMARY_SUCCESS = "SHIFT_SUMMARY_SUCCESS";
export const SHIFT_SUMMARY_ERROR = "SHIFT_SUMMARY_ERROR";

export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

export const SHIFT_SCHEDULE_LIST = "SHIFT_SCHEDULE_LIST";
export const SHIFT_SCHEDULE_LIST_SUCCESS = "SHIFT_SCHEDULE_LIST_SUCCESS";
export const SHIFT_SCHEDULE_LIST_ERROR = "SHIFT_SCHEDULE_LIST_ERROR";

export const SHIFT_SKILL_CREW_LIST = "SHIFT_SKILL_CREW_LIST";
export const SHIFT_SKILL_CREW_LIST_SUCCESS = "SHIFT_SKILL_CREW_LIST_SUCCESS";
export const SHIFT_SKILL_CREW_LIST_ERROR = "SHIFT_SKILL_CREW_LIST_ERROR";

export const NOTIFICATIONS_FETCH = "NOTIFICATIONS_FETCH";
export const NOTIFICATIONS_FETCH_SUCCESS = "NOTIFICATIONS_FETCH_SUCCESS";
export const NOTIFICATIONS_FETCH_ERROR = "NOTIFICATIONS_FETCH_ERROR";

export const NOTIFICATION_READ = "NOTIFICATION_READ";
export const NOTIFICATION_READ_SUCCESS = "NOTIFICATION_READ_SUCCESS";
export const NOTIFICATION_READ_ERROR = "NOTIFICATION_READ_ERROR";

export const NOTIFICATIONS_FETCH_DROPDOWN = "NOTIFICATIONS_FETCH_DROPDOWN";
export const NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS = "NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS";
export const NOTIFICATIONS_FETCH_DROPDOWN_ERROR = "NOTIFICATIONS_FETCH_DROPDOWN_ERROR";

export const SHIFT_SCHEDULE_CREW = "SHIFT_SCHEDULE_CREW";
export const SHIFT_SCHEDULE_CREW_SUCCESS = "SHIFT_SCHEDULE_CREW_SUCCESS";
export const SHIFT_SCHEDULE_CREW_ERROR = "SHIFT_SCHEDULE_CREW_ERROR";

export const SHIFT_SCHEDULE_CREW_SEND_REQUEST = "SHIFT_SCHEDULE_CREW_SEND_REQUEST";
export const SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS = "SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS";
export const SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR = "SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR";

export const LOGIN_CLIENT_AFFILIATE_LIST = "LOGIN_CLIENT_AFFILIATE_LIST";
export const LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS = "LOGIN_CLIENT_AFFILIATE_LIST_SUCCESS";
export const LOGIN_CLIENT_AFFILIATE_LIST_ERROR = "LOGIN_CLIENT_AFFILIATE_LIST_ERROR";

export const CREW_SCHEDULE_SHIFT_STATUS = "CREW_SCHEDULE_SHIFT_STATUS";
export const CREW_SCHEDULE_SHIFT_STATUS_SUCCESS = "CREW_SCHEDULE_SHIFT_STATUS_SUCCESS";
export const CREW_SCHEDULE_SHIFT_STATUS_ERROR = "CREW_SCHEDULE_SHIFT_STATUS_ERROR";

export const CREW_SCHEDULE_SHIFT_CHECKIN = "CREW_SCHEDULE_SHIFT_CHECKIN";
export const CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS = "CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS";
export const CREW_SCHEDULE_SHIFT_CHECKIN_ERROR = "CREW_SCHEDULE_SHIFT_CHECKIN_ERROR"; 

export const CREW_SCHEDULE_SHIFT_CHECKOUT = "CREW_SCHEDULE_SHIFT_CHECKOUT";
export const CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS = "CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS";
export const CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR = "CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR";

export const CREW_REMOVAL_FROM_SHIFT = "CREW_REMOVAL_FROM_SHIFT";
export const CREW_REMOVAL_FROM_SHIFT_SUCCESS = "CREW_REMOVAL_FROM_SHIFT_SUCCESS";
export const CREW_REMOVAL_FROM_SHIFT_ERROR = "CREW_REMOVAL_FROM_SHIFT_ERROR"; 

export const TIMESHEET_LIST = "TIMESHEET_LIST";
export const TIMESHEET_LIST_SUCCESS = "TIMESHEET_LIST_SUCCESS";
export const TIMESHEET_LIST_ERROR = "TIMESHEET_LIST_ERROR";

export const TIMESHEET_SHIFT_LIST = "TIMESHEET_SHIFT_LIST";
export const TIMESHEET_SHIFT_LIST_SUCCESS = "TIMESHEET_SHIFT_LIST_SUCCESS";
export const TIMESHEET_SHIFT_LIST_ERROR = "TIMESHEET_SHIFT_LIST_ERROR";

export const TIMESHEET_DETAILS = "TIMESHEET_DETAILS";
export const TIMESHEET_DETAILS_SUCCESS = "TIMESHEET_DETAILS_SUCCESS";
export const TIMESHEET_DETAILS_ERROR = "TIMESHEET_DETAILS_ERROR";

export const TIMESHEET_UPDATE = "TIMESHEET_UPDATE";
export const TIMESHEET_UPDATE_SUCCESS = "TIMESHEET_UPDATE_SUCCESS";
export const TIMESHEET_UPDATE_ERROR = "TIMESHEET_UPDATE_ERROR";

export const FEEDBACK_LIST = "FEEDBACK_LIST";
export const FEEDBACK_LIST_SUCCESS = "FEEDBACK_LIST_SUCCESS";
export const FEEDBACK_LIST_ERROR = "FEEDBACK_LIST_ERROR";

export const FEEDBACK_DETAILS = "FEEDBACK_DETAILS";
export const FEEDBACK_DETAILS_SUCCESS = "FEEDBACK_DETAILS_SUCCESS";
export const FEEDBACK_DETAILS_ERROR = "FEEDBACK_DETAILS_ERROR";

export const FEEDBACK_UPDATE = "FEEDBACK_UPDATE";
export const FEEDBACK_UPDATE_SUCCESS = "FEEDBACK_UPDATE_SUCCESS";
export const FEEDBACK_UPDATE_ERROR = "FEEDBACK_UPDATE_ERROR";

export const FEEDBACK_STAR_RATING = "FEEDBACK_STAR_RATING";
export const FEEDBACK_STAR_RATING_SUCCESS = "FEEDBACK_STAR_RATING_SUCCESS";
export const FEEDBACK_STAR_RATING_ERROR = "FEEDBACK_STAR_RATING_ERROR";

export const SCHEDULE_DATE_VIEW         = "SCHEDULE_DATE_VIEW";
export const SCHEDULE_DATE_VIEW_SUCCESS = "SCHEDULE_DATE_VIEW_SUCCESS";
export const SCHEDULE_DATE_VIEW_ERROR   = "SCHEDULE_DATE_VIEW_ERROR";

export const SCHEDULE_CREW_VIEW         = "SCHEDULE_CREW_VIEW";
export const SCHEDULE_CREW_VIEW_SUCCESS = "SCHEDULE_CREW_VIEW_SUCCESS";
export const SCHEDULE_CREW_VIEW_ERROR   = "SCHEDULE_CREW_VIEW_ERROR";

export const TIMEZONES_LIST         = "TIMEZONES_LIST";
export const TIMEZONES_LIST_SUCCESS = "TIMEZONES_LIST_SUCCESS";
export const TIMEZONES_LIST_ERROR   = "TIMEZONES_LIST_ERROR";

export const SERVER_TIME_LIST   = "SERVER_TIME_LIST";
export const SERVER_TIME_LIST_SUCCESS   = "SERVER_TIME_LIST_SUCCESS";
export const SERVER_TIME_LIST_ERROR   = "SERVER_TIME_LIST_ERROR";

export const GET_SHIFT_IDS_FOR_SCHEDULE         = "GET_SHIFT_IDS_FOR_SCHEDULE";
export const CLEAR_SHIFT_IDS_FOR_SCHEDULE       = "CLEAR_SHIFT_IDS_FOR_SCHEDULE";

export const CLIENT_IMPORT                  = "CLIENT_IMPORT";
export const CLIENT_IMPORT_SUCCESS          = "CLIENT_IMPORT_SUCCESS";
export const CLIENT_IMPORT_ERROR            = "CLIENT_IMPORT_ERROR";

export const CLIENT_IMPORT_QUICK_FILE                  = "CLIENT_IMPORT_QUICK_FILE";
export const CLIENT_IMPORT_QUICK_FILE_SUCCESS          = "CLIENT_IMPORT_QUICK_FILE_SUCCESS";
export const CLIENT_IMPORT_QUICK_FILE_ERROR            = "CLIENT_IMPORT_QUICK_FILE_ERROR";

export const CLIENT_CONTACT_IMPORT                  = "CLIENT_CONTACT_IMPORT";
export const CLIENT_CONTACT_IMPORT_SUCCESS          = "CLIENT_CONTACT_IMPORT_SUCCESS";
export const CLIENT_CONTACT_IMPORT_ERROR            = "CLIENT_CONTACT_IMPORT_ERROR";

export const FILTER_CLIENTS_LIST          = "FILTER_CLIENTS_LIST";
export const FILTER_CLIENTS_LIST_SUCCESS  = "FILTER_CLIENTS_LIST_SUCCESS";
export const FILTER_CLIENTS_LIST_ERROR    = "FILTER_CLIENTS_LIST_ERROR";

export const SHIFTS_FILTER_EVENTS_LIST          = "SHIFTS_FILTER_EVENTS_LIST";
export const SHIFTS_FILTER_EVENTS_LIST_SUCCESS  = "SHIFTS_FILTER_EVENTS_LIST_SUCCESS";
export const SHIFTS_FILTER_EVENTS_LIST_ERROR    = "SHIFTS_FILTER_EVENTS_LIST_ERROR";

export const SHIFTS_FILTER_SHIFTS_LIST          = "SHIFTS_FILTER_SHIFTS_LIST";
export const SHIFTS_FILTER_SHIFTS_LIST_SUCCESS  = "SHIFTS_FILTER_SHIFTS_LIST_SUCCESS";
export const SHIFTS_FILTER_SHIFTS_LIST_ERROR    = "SHIFTS_FILTER_SHIFTS_LIST_ERROR"; 

export const SHIFTS_FILTER_LOCATIONS_LIST          = "SHIFTS_FILTER_LOCATIONS_LIST";
export const SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS  = "SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS";
export const SHIFTS_FILTER_LOCATIONS_LIST_ERROR    = "SHIFTS_FILTER_LOCATIONS_LIST_ERROR"; 

export const CREW_UNAVAILABILITY          = "CREW_UNAVAILABILITY";
export const CREW_UNAVAILABILITY_SUCCESS  = "CREW_UNAVAILABILITY_SUCCESS";
export const CREW_UNAVAILABILITY_ERROR    = "CREW_UNAVAILABILITY_ERROR"; 

export const CREW_UNAVAILABILITY_PER_DATE          = "CREW_UNAVAILABILITY_PER_DATE";
export const CREW_UNAVAILABILITY_PER_DATE_SUCCESS  = "CREW_UNAVAILABILITY_PER_DATE_SUCCESS";
export const CREW_UNAVAILABILITY_PER_DATE_ERROR    = "CREW_UNAVAILABILITY_PER_DATE_ERROR"; 

export const UNAVAILABLE_CREW_LIST          = "UNAVAILABLE_CREW_LIST";
export const UNAVAILABLE_CREW_LIST_SUCCESS  = "UNAVAILABLE_CREW_LIST_SUCCESS";
export const UNAVAILABLE_CREW_LIST_ERROR    = "UNAVAILABLE_CREW_LIST_ERROR"; 

export const SAVE_UNAVAILABILITY          = "SAVE_UNAVAILABILITY";
export const SAVE_UNAVAILABILITY_SUCCESS  = "SAVE_UNAVAILABILITY_SUCCESS";
export const SAVE_UNAVAILABILITY_ERROR    = "SAVE_UNAVAILABILITY_ERROR"; 

export const UPDATE_UNAVAILABILITY          = "UPDATE_UNAVAILABILITY";
export const UPDATE_UNAVAILABILITY_SUCCESS  = "UPDATE_UNAVAILABILITY_SUCCESS";
export const UPDATE_UNAVAILABILITY_ERROR    = "UPDATE_UNAVAILABILITY_ERROR";

export const DELETE_UNAVAILABILITY          = "DELETE_UNAVAILABILITY";
export const DELETE_UNAVAILABILITY_SUCCESS  = "DELETE_UNAVAILABILITY_SUCCESS";
export const DELETE_UNAVAILABILITY_ERROR    = "DELETE_UNAVAILABILITY_ERROR";

export const GET_UNAVAILABILITY          = "GET_UNAVAILABILITY";
export const GET_UNAVAILABILITY_SUCCESS  = "GET_UNAVAILABILITY_SUCCESS";
export const GET_UNAVAILABILITY_ERROR    = "GET_UNAVAILABILITY_ERROR"; 

export const EVENTS_FILTER_EVENTS_LIST          = "EVENTS_FILTER_EVENTS_LIST";
export const EVENTS_FILTER_EVENTS_LIST_SUCCESS  = "EVENTS_FILTER_EVENTS_LIST_SUCCESS";
export const EVENTS_FILTER_EVENTS_LIST_ERROR    = "EVENTS_FILTER_EVENTS_LIST_ERROR";

export const EVENTS_FILTER_LOCATIONS_LIST          = "EVENTS_FILTER_LOCATIONS_LIST";
export const EVENTS_FILTER_LOCATIONS_LIST_SUCCESS  = "EVENTS_FILTER_LOCATIONS_LIST_SUCCESS";
export const EVENTS_FILTER_LOCATIONS_LIST_ERROR    = "EVENTS_FILTER_LOCATIONS_LIST_ERROR"; 

export const DASHBOARD_ACTION_REQUIRED_LIST          = "DASHBOARD_ACTION_REQUIRED_LIST";
export const DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS  = "DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS";
export const DASHBOARD_ACTION_REQUIRED_LIST_ERROR    = "DASHBOARD_ACTION_REQUIRED_LIST_ERROR";

export const DASHBOARD_CLIENT_ACTION_REQUIRED_LIST          = "DASHBOARD_CLIENT_ACTION_REQUIRED_LIST";
export const DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS  = "DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS";
export const DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_ERROR    = "DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_ERROR";


export const DASHBOARD_CHART_DATA_LIST          = "DASHBOARD_CHART_DATA_LIST";
export const DASHBOARD_CHART_DATA_LIST_SUCCESS  = "DASHBOARD_CHART_DATA_LIST_SUCCESS";
export const DASHBOARD_CHART_DATA_LIST_ERROR    = "DASHBOARD_CHART_DATA_LIST_ERROR"; 

export const DASHBOARD_CLIENT_CHART_DATA_LIST          = "DASHBOARD_CLIENT_CHART_DATA_LIST";
export const DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS  = "DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS";
export const DASHBOARD_CLIENT_CHART_DATA_LIST_ERROR    = "DASHBOARD_CLIENT_CHART_DATA_LIST_ERROR"; 

export const ASSOC_USER_ACTIVE      = "ASSOC_USER_ACTIVE";
export const ASSOC_USER_DEACTIVE    = "ASSOC_USER_DEACTIVE";

export const INVITE_AS_FRIEND          = "INVITE_AS_FRIEND";
export const INVITE_AS_FRIEND_SUCCESS  = "INVITE_AS_FRIEND_SUCCESS";
export const INVITE_AS_FRIEND_ERROR    = "INVITE_AS_FRIEND_ERROR"; 

export const FEEDBACK_FILTER_EVENTS_LIST          = "FEEDBACK_FILTER_EVENTS_LIST";
export const FEEDBACK_FILTER_EVENTS_LIST_SUCCESS  = "FEEDBACK_FILTER_EVENTS_LIST_SUCCESS";
export const FEEDBACK_FILTER_EVENTS_LIST_ERROR    = "FEEDBACK_FILTER_EVENTS_LIST_ERROR"; 

export const FEEDBACK_FILTER_REVIEWERS_LIST          = "FEEDBACK_FILTER_REVIEWERS_LIST";
export const FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS  = "FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS";
export const FEEDBACK_FILTER_REVIEWERS_LIST_ERROR    = "FEEDBACK_FILTER_REVIEWERS_LIST_ERROR"; 

export const SHIFT_SEQ_NUMBER = "SHIFT_SEQ_NUMBER";
export const SHIFT_SEQ_NUMBER_SUCCESS  = "SHIFT_SEQ_NUMBER_SUCCESS";
export const SHIFT_SEQ_NUMBER_ERROR    = "SHIFT_SEQ_NUMBER_ERROR"; 

export const LOGIN_AS_SET_DATA         = "LOGIN_AS_SET_DATA";
export const LOGIN_AS_RESET_DATA       = "LOGIN_AS_RESET_DATA";

export const LOGIN_AS_USER              = 'LOGIN_AS_USER';
export const LOGIN_AS_USER_SUCCESS      = 'LOGIN_AS_USER_SUCCESS';
export const LOGIN_AS_USER_ERROR        = 'LOGIN_AS_USER_ERROR';

export const PAY_LEVELS_LIST           = 'PAY_LEVELS_LIST';
export const PAY_LEVELS_LIST_SUCCESS   = "PAY_LEVELS_LIST_SUCCESS";
export const PAY_LEVELS_LIST_ERROR     = "PAY_LEVELS_LIST_ERROR";

export const PAY_LEVELS_ADD            = 'PAY_LEVELS_ADD';
export const PAY_LEVELS_ADD_SUCCESS    = "PAY_LEVELS_ADD_SUCCESS";
export const PAY_LEVELS_ADD_ERROR      = "PAY_LEVELS_ADD_ERROR";

export const PAY_LEVELS_EDIT           = 'PAY_LEVELS_EDIT';
export const PAY_LEVELS_EDIT_SUCCESS   = "PAY_LEVELS_EDIT_SUCCESS";
export const PAY_LEVELS_EDIT_ERROR     = "PAY_LEVELS_EDIT_ERROR";

export const PAY_LEVELS_UPDATE         = 'PAY_LEVELS_UPDATE';
export const PAY_LEVELS_UPDATE_SUCCESS = "PAY_LEVELS_UPDATE_SUCCESS";
export const PAY_LEVELS_UPDATE_ERROR   = "PAY_LEVELS_UPDATE_ERROR";

export const PAY_LEVELS_DELETE         = 'PAY_LEVELS_DELETE';
export const PAY_LEVELS_DELETE_SUCCESS = "PAY_LEVELS_DELETE_SUCCESS";
export const PAY_LEVELS_DELETE_ERROR   = "PAY_LEVELS_DELETE_ERROR";

export const SA_PROFILE_DETAILS         = 'SA_PROFILE_DETAILS';
export const SA_PROFILE_DETAILS_SUCCESS = "SA_PROFILE_DETAILS_SUCCESS";
export const SA_PROFILE_DETAILS_ERROR   = "SA_PROFILE_DETAILS_ERROR";

export const SA_PROFILE_DETAILS_UPDATE         = 'SA_PROFILE_DETAILS_UPDATE';
export const SA_PROFILE_DETAILS_UPDATE_SUCCESS = "SA_PROFILE_DETAILS_UPDATE_SUCCESS";
export const SA_PROFILE_DETAILS_UPDATE_ERROR   = "SA_PROFILE_DETAILS_UPDATE_ERROR";

export const CERTIFICATES_LIST         = 'CERTIFICATES_LIST';
export const CERTIFICATES_LIST_SUCCESS = "CERTIFICATES_LIST_SUCCESS";
export const CERTIFICATES_LIST_ERROR   = "CERTIFICATES_LIST_ERROR";

export const OMNU_POINTS_PP_LIST           = 'OMNU_POINTS_PP_LIST';
export const OMNU_POINTS_PP_LIST_SUCCESS   = "OMNU_POINTS_PP_LIST_SUCCESS";
export const OMNU_POINTS_PP_LIST_ERROR     = "OMNU_POINTS_PP_LIST_ERROR";

export const OMNU_POINTS_PP_ADD            = 'OMNU_POINTS_PP_ADD';
export const OMNU_POINTS_PP_ADD_SUCCESS    = "OMNU_POINTS_PP_ADD_SUCCESS";
export const OMNU_POINTS_PP_ADD_ERROR      = "OMNU_POINTS_PP_ADD_ERROR";

export const OMNU_POINTS_PP_EDIT           = 'OMNU_POINTS_PP_EDIT';
export const OMNU_POINTS_PP_EDIT_SUCCESS   = "OMNU_POINTS_PP_EDIT_SUCCESS";
export const OMNU_POINTS_PP_EDIT_ERROR     = "OMNU_POINTS_PP_EDIT_ERROR";

export const OMNU_POINTS_PP_UPDATE         = 'OMNU_POINTS_PP_UPDATE';
export const OMNU_POINTS_PP_UPDATE_SUCCESS = "OMNU_POINTS_PP_UPDATE_SUCCESS";
export const OMNU_POINTS_PP_UPDATE_ERROR   = "OMNU_POINTS_PP_UPDATE_ERROR";

export const OMNU_POINTS_PP_DELETE         = 'OMNU_POINTS_PP_DELETE';
export const OMNU_POINTS_PP_DELETE_SUCCESS = "OMNU_POINTS_PP_DELETE_SUCCESS";
export const OMNU_POINTS_PP_DELETE_ERROR   = "OMNU_POINTS_PP_DELETE_ERROR";

export const GET_AFFILIATE_CHEIF_BONUS         = 'GET_AFFILIATE_CHEIF_BONUS';
export const GET_AFFILIATE_CHEIF_BONUS_SUCCESS = "GET_AFFILIATE_CHEIF_BONUS_SUCCESS";
export const GET_AFFILIATE_CHEIF_BONUS_ERROR   = "GET_AFFILIATE_CHEIF_BONUS_ERROR";

export const UPDATE_AFFILIATE_CHEIF_BONUS         = 'UPDATE_AFFILIATE_CHEIF_BONUS';
export const UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS = "UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS";
export const UPDATE_AFFILIATE_CHEIF_BONUS_ERROR   = "UPDATE_AFFILIATE_CHEIF_BONUS_ERROR";

export const DOCUMENT_STATUS_UPDATE         = 'DOCUMENT_STATUS_UPDATE';
export const DOCUMENT_STATUS_UPDATE_SUCCESS = "DOCUMENT_STATUS_UPDATE_SUCCESS";
export const DOCUMENT_STATUS_UPDATE_ERROR   = "DOCUMENT_STATUS_UPDATE_ERROR";

export const CLIENT_PROFILE_TAB_ACTIVE      = "CLIENT_PROFILE_TAB_ACTIVE";
export const CLIENT_PROFILE_TAB_DEACTIVE    = "CLIENT_PROFILE_TAB_DEACTIVE";

export const CREW_PROFILE_TAB_ACTIVE      = "CREW_PROFILE_TAB_ACTIVE";
export const CREW_PROFILE_TAB_DEACTIVE    = "CREW_PROFILE_TAB_DEACTIVE";

export const EXPIRING_CERTIFICATE_TITLE    = "EXPIRING_CERTIFICATE_TITLE";

export const TIMESHEET_FILTER_EVENTS         = 'TIMESHEET_FILTER_EVENTS';
export const TIMESHEET_FILTER_EVENTS_SUCCESS = "TIMESHEET_FILTER_EVENTS_SUCCESS";
export const TIMESHEET_FILTER_EVENTS_ERROR   = "TIMESHEET_FILTER_EVENTS_ERROR";

export const TIMESHEET_FILTER_LOCATION         = 'TIMESHEET_FILTER_LOCATION';
export const TIMESHEET_FILTER_LOCATION_SUCCESS = "TIMESHEET_FILTER_LOCATION_SUCCESS";
export const TIMESHEET_FILTER_LOCATION_ERROR   = "TIMESHEET_FILTER_LOCATION_ERROR";

export const TIMESHEET_FILTER_CREW         = 'TIMESHEET_FILTER_CREW';
export const TIMESHEET_FILTER_CREW_SUCCESS = "TIMESHEET_FILTER_CREW_SUCCESS";
export const TIMESHEET_FILTER_CREW_ERROR   = "TIMESHEET_FILTER_CREW_ERROR";

export const TIMESHEET_FILTER_DEPARTMENT         = 'TIMESHEET_FILTER_DEPARTMENT';
export const TIMESHEET_FILTER_DEPARTMENT_SUCCESS = "TIMESHEET_FILTER_DEPARTMENT_SUCCESS";
export const TIMESHEET_FILTER_DEPARTMENT_ERROR   = "TIMESHEET_FILTER_DEPARTMENT_ERROR";

export const TIMESHEET_FILTER_SKILL        = 'TIMESHEET_FILTER_SKILL';
export const TIMESHEET_FILTER_SKILL_SUCCESS = "TIMESHEET_FILTER_SKILL_SUCCESS";
export const TIMESHEET_FILTER_SKILL_ERROR   = "TIMESHEET_FILTER_SKILL_ERROR";

export const EVENT_POPUP_ID_SET             = 'EVENT_POPUP_ID_SET';
export const EVENT_POPUP_ID_RESET           = 'EVENT_POPUP_ID_RESET';

export const SHIFT_POPUP_ID_SET             = 'SHIFT_POPUP_ID_SET';
export const SHIFT_POPUP_ID_RESET           = 'SHIFT_POPUP_ID_RESET'; 

export const VALIDATE_CLIENT_ADD            = 'VALIDATE_CLIENT_ADD';
export const VALIDATE_CLIENT_ADD_SUCCESS    = 'VALIDATE_CLIENT_ADD_SUCCESS';
export const VALIDATE_CLIENT_ADD_ERROR      = 'VALIDATE_CLIENT_ADD_ERROR';

export const VALIDATE_CLIENT_DETAILS        = 'VALIDATE_CLIENT_DETAILS';
export const VALIDATE_CLIENT_DETAILS_SUCCESS= 'VALIDATE_CLIENT_DETAILS_SUCCESS';
export const VALIDATE_CLIENT_DETAILS_ERROR  = 'VALIDATE_CLIENT_DETAILS_ERROR';

export const VALIDATE_EVENT_ADD             = 'VALIDATE_EVENT_ADD';
export const VALIDATE_EVENT_ADD_SUCCESS     = 'VALIDATE_EVENT_ADD_SUCCESS';
export const VALIDATE_EVENT_ADD_ERROR       = 'VALIDATE_EVENT_ADD_ERROR';

export const VALIDATE_CREW_ADD              = 'VALIDATE_CREW_ADD';
export const VALIDATE_CREW_ADD_SUCCESS      = 'VALIDATE_CREW_ADD_SUCCESS';
export const VALIDATE_CREW_ADD_ERROR        = 'VALIDATE_CREW_ADD_ERROR';

export const VALIDATE_CREW_DETAILS          = 'VALIDATE_CREW_DETAILS';
export const VALIDATE_CREW_DETAILS_SUCCESS  = 'VALIDATE_CREW_DETAILS_SUCCESS';
export const VALIDATE_CREW_DETAILS_ERROR    = 'VALIDATE_CREW_DETAILS_ERROR';

export const EVENT_COMPLETE                 = 'EVENT_COMPLETE';
export const EVENT_COMPLETE_SUCCESS         = 'EVENT_COMPLETE_SUCCESS';
export const EVENT_COMPLETE_ERROR           = 'EVENT_COMPLETE_ERROR';

export const CLIENT_GET_CREW_CHIEF_BONUS            = 'CLIENT_GET_CREW_CHIEF_BONUS';
export const CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS    = 'CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS';
export const CLIENT_GET_CREW_CHIEF_BONUS_ERROR      = 'CLIENT_GET_CREW_CHIEF_BONUS_ERROR';

export const CLIENT_UPDATE_CREW_CHIEF_BONUS         = 'CLIENT_UPDATE_CREW_CHIEF_BONUS';
export const CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS = 'CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS';
export const CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR   = 'CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR';

export const CLIENT_CONTACT_DELETE                 = 'CLIENT_CONTACT_DELETE';
export const CLIENT_CONTACT_DELETE_SUCCESS         = 'CLIENT_CONTACT_DELETE_SUCCESS';
export const CLIENT_CONTACT_DELETE_ERROR           = 'CLIENT_CONTACT_DELETE_ERROR';

export const UPDATE_SKILL_INDEX                 = 'UPDATE_SKILL_INDEX';
export const UPDATE_SKILL_INDEX_SUCCESS         = 'UPDATE_SKILL_INDEX_SUCCESS';
export const UPDATE_SKILL_INDEX_ERROR           = 'UPDATE_SKILL_INDEX_ERROR';

export const RESET_PASSWORD_VERIFICATION        = 'RESET_PASSWORD_VERIFICATION';
export const RESET_PASSWORD_VERIFICATION_SUCCESS= 'RESET_PASSWORD_VERIFICATION_SUCCESS';
export const RESET_PASSWORD_VERIFICATION_ERROR  = 'RESET_PASSWORD_VERIFICATION_ERROR';

export const SCHEDULE_SHIFT_CREW                = 'SCHEDULE_SHIFT_CREW';
export const SCHEDULE_SHIFT_CREW_SUCCESS        = 'SCHEDULE_SHIFT_CREW_SUCCESS';
export const SCHEDULE_SHIFT_CREW_ERROR          = 'SCHEDULE_SHIFT_CREW_ERROR';

export const TIMESHEET_CSV_DOWNLOAD                = 'TIMESHEET_CSV_DOWNLOAD';
export const TIMESHEET_CSV_DOWNLOAD_SUCCESS        = 'TIMESHEET_CSV_DOWNLOAD_SUCCESS';
export const TIMESHEET_CSV_DOWNLOAD_ERROR          = 'TIMESHEET_CSV_DOWNLOAD_ERROR';

export const TIMESHEET_SUMMARY_CSV_DOWNLOAD                = 'TIMESHEET_SUMMARY_CSV_DOWNLOAD';
export const TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS        = 'TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS';
export const TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR          = 'TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR';

export const EVENT_DISCOUNT_EDIT                = 'EVENT_DISCOUNT_EDIT';
export const EVENT_DISCOUNT_EDIT_SUCCESS        = 'EVENT_DISCOUNT_EDIT_SUCCESS';
export const EVENT_DISCOUNT_EDIT_ERROR          = 'EVENT_DISCOUNT_EDIT_ERROR';

export const EVENT_LIST_DOWNLOAD                = 'EVENT_LIST_DOWNLOAD';
export const EVENT_LIST_DOWNLOAD_SUCCESS        = 'EVENT_LIST_DOWNLOAD_SUCCESS';
export const EVENT_LIST_DOWNLOAD_ERROR          = 'EVENT_LIST_DOWNLOAD_ERROR';

export const INVOICE_LIST_DOWNLOAD                = 'INVOICE_LIST_DOWNLOAD';
export const INVOICE_LIST_DOWNLOAD_SUCCESS        = 'INVOICE_LIST_DOWNLOAD_SUCCESS';
export const INVOICE_LIST_DOWNLOAD_ERROR          = 'INVOICE_LIST_DOWNLOAD_ERROR';

export const CREW_LIST_DOWNLOAD                = 'CREW_LIST_DOWNLOAD';
export const CREW_LIST_DOWNLOAD_SUCCESS        = 'CREW_LIST_DOWNLOAD_SUCCESS';
export const CREW_LIST_DOWNLOAD_ERROR          = 'CREW_LIST_DOWNLOAD_ERROR'; 

export const SCHEDULE_SET_SUB_TITLE_FROM_TO_DATE='SCHEDULE_SET_SUB_TITLE_FROM_TO_DATE'; // FOR SCHDULE PAGE HEADER  

export const FILTER_AFFILIATE_LIST          = "FILTER_AFFILIATE_LIST";
export const FILTER_AFFILIATE_LIST_SUCCESS  = "FILTER_AFFILIATE_LIST_SUCCESS";
export const FILTER_AFFILIATE_LIST_ERROR    = "FILTER_AFFILIATE_LIST_ERROR";

export const SKILL_SUGGESTION               = "SKILL_SUGGESTION";
export const SKILL_SUGGESTION_SUCCESS       = "SKILL_SUGGESTION_SUCCESS";
export const SKILL_SUGGESTION_ERROR         = "SKILL_SUGGESTION_ERROR";

export const SHIFT_SUMMARY_ALL_CREW         = "SHIFT_SUMMARY_ALL_CREW";
export const SHIFT_SUMMARY_ALL_CREW_SUCCESS = "SHIFT_SUMMARY_ALL_CREW_SUCCESS";
export const SHIFT_SUMMARY_ALL_CREW_ERROR   = "SHIFT_SUMMARY_ALL_CREW_ERROR";

export const EVENT_SHIFTS_LIST              = "EVENT_SHIFTS_LIST";
export const EVENT_SHIFTS_LIST_SUCCESS      = "EVENT_SHIFTS_LIST_SUCCESS";
export const EVENT_SHIFTS_LIST_ERROR        = "EVENT_SHIFTS_LIST_ERROR";

export const EVENT_SHIFT_CREW_LIST          = "EVENT_SHIFT_CREW_LIST";
export const EVENT_SHIFT_CREW_LIST_SUCCESS  = "EVENT_SHIFT_CREW_LIST_SUCCESS";
export const EVENT_SHIFT_CREW_LIST_ERROR    = "EVENT_SHIFT_CREW_LIST_ERROR";

export const SCHEDULE_DATE_VIEW_CALENDAR          = "SCHEDULE_DATE_VIEW_CALENDAR";
export const SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS  = "SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS";
export const SCHEDULE_DATE_VIEW_CALENDAR_ERROR    = "SCHEDULE_DATE_VIEW_CALENDAR_ERROR";

export const SCHED_DATE_VIEW_CALENDAR_DATE        = "SCHED_DATE_VIEW_CALENDAR_DATE";
export const SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS= "SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS";
export const SCHED_DATE_VIEW_CALENDAR_DATE_ERROR  = "SCHED_DATE_VIEW_CALENDAR_DATE_ERROR";

export const CREW_LIST_SLIDER_CREWID        = "CREW_LIST_SLIDER_CREWID";
export const CLIENT_LIST_SLIDER_CLIENTID    = "CLIENT_LIST_SLIDER_CLIENTID";

export const CHIEF_REVIEWERS_LIST           = "CHIEF_REVIEWERS_LIST";
export const CHIEF_REVIEWERS_LIST_SUCCESS   = "CHIEF_REVIEWERS_LIST_SUCCESS";
export const CHIEF_REVIEWERS_LIST_ERROR     = "CHIEF_REVIEWERS_LIST_ERROR";

export const CREW_TIMESHEET_LIST           = "CREW_TIMESHEET_LIST";
export const CREW_TIMESHEET_LIST_SUCCESS   = "CREW_TIMESHEET_LIST_SUCCESS";
export const CREW_TIMESHEET_LIST_ERROR     = "CREW_TIMESHEET_LIST_ERROR";

export const SHIFT_CREW_LIST_DOWNLOAD                = 'SHIFT_CREW_LIST_DOWNLOAD';
export const SHIFT_CREW_LIST_DOWNLOAD_SUCCESS        = 'SHIFT_CREW_LIST_DOWNLOAD_SUCCESS';
export const SHIFT_CREW_LIST_DOWNLOAD_ERROR          = 'SHIFT_CREW_LIST_DOWNLOAD_ERROR';

export const EVENT_MESSAGES_LIST                = 'EVENT_MESSAGES_LIST';
export const EVENT_MESSAGES_LIST_SUCCESS        = 'EVENT_MESSAGES_LIST_SUCCESS';
export const EVENT_MESSAGES_LIST_ERROR          = 'EVENT_MESSAGES_LIST_ERROR';

export const CREW_FEEDBACK_LIST           = "CREW_FEEDBACK_LIST";
export const CREW_FEEDBACK_LIST_SUCCESS   = "CREW_FEEDBACK_LIST_SUCCESS";
export const CREW_FEEDBACK_LIST_ERROR     = "CREW_FEEDBACK_LIST_ERROR";

export const PROFILE_CLIENT_CATEGORY_LIST           		= "PROFILE_CLIENT_CATEGORY_LIST";
export const PROFILE_CLIENT_CATEGORY_LIST_SUCCESS   		= "PROFILE_CLIENT_CATEGORY_LIST_SUCCESS";
export const PROFILE_CLIENT_CATEGORY_LIST_ERROR     		= "PROFILE_CLIENT_CATEGORY_LIST_ERROR";

export const NOTIFICATIONS_ALL_MARK_AS_READ          = "NOTIFICATIONS_ALL_MARK_AS_READ";
export const NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS  = "NOTIFICATIONS_ALL_MARK_AS_READ_SUCCESS";
export const NOTIFICATIONS_ALL_MARK_AS_READ_ERROR    = "NOTIFICATIONS_ALL_MARK_AS_READ_ERROR";

export const CLIENT_LIST_FOR_CATEGORIES           		= "CLIENT_LIST_FOR_CATEGORIES";
export const CLIENT_LIST_FOR_CATEGORIES_SUCCESS   		= "CLIENT_LIST_FOR_CATEGORIES_SUCCESS";
export const CLIENT_LIST_FOR_CATEGORIES_ERROR     		= "CLIENT_LIST_FOR_CATEGORIES_ERROR";

export const SEND_EVENT_MESSAGE           				= "SEND_EVENT_MESSAGE";
export const SEND_EVENT_MESSAGE_SUCCESS   				= "SEND_EVENT_MESSAGE_SUCCESS";
export const SEND_EVENT_MESSAGE_ERROR     				= "SEND_EVENT_MESSAGE_ERROR";

export const SHIFT_TIME_CHANGE_REQUEST           		= "SHIFT_TIME_CHANGE_REQUEST";
export const SHIFT_TIME_CHANGE_REQUEST_SUCCESS   		= "SHIFT_TIME_CHANGE_REQUEST_SUCCESS";
export const SHIFT_TIME_CHANGE_REQUEST_ERROR     		= "SHIFT_TIME_CHANGE_REQUEST_ERROR";

export const SHIFT_TIME_CHANGE_REQUEST_COUNT           		= "SHIFT_TIME_CHANGE_REQUEST_COUNT";
export const SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS   		= "SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS";
export const SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR     		= "SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR";

export const COPY_MASTER_CARD_TO_CLIENT           		= "COPY_MASTER_CARD_TO_CLIENT";
export const COPY_MASTER_CARD_TO_CLIENT_SUCCESS   		= "COPY_MASTER_CARD_TO_CLIENT_SUCCESS";
export const COPY_MASTER_CARD_TO_CLIENT_ERROR     		= "COPY_MASTER_CARD_TO_CLIENT_ERROR";

export const COPY_CATEGORY_TO_CATEGORY           		= "COPY_CATEGORY_TO_CATEGORY";
export const COPY_CATEGORY_TO_CATEGORY_SUCCESS   		= "COPY_CATEGORY_TO_CATEGORY_SUCCESS";
export const COPY_CATEGORY_TO_CATEGORY_ERROR     		= "COPY_CATEGORY_TO_CATEGORY_ERROR";

export const CLIENT_COMPANY_BASIC_INFO           		= "CLIENT_COMPANY_BASIC_INFO";
export const CLIENT_COMPANY_BASIC_INFO_SUCCESS   		= "CLIENT_COMPANY_BASIC_INFO_SUCCESS";
export const CLIENT_COMPANY_BASIC_INFO_ERROR     		= "CLIENT_COMPANY_BASIC_INFO_ERROR";

export const SET_ACTION_NEEEDED                         = "SET_ACTION_NEEEDED";

export const UNALLOCATED_SHIFTS_COUNT           		= "UNALLOCATED_SHIFTS_COUNT";
export const UNALLOCATED_SHIFTS_COUNT_SUCCESS   		= "UNALLOCATED_SHIFTS_COUNT_SUCCESS";
export const UNALLOCATED_SHIFTS_COUNT_ERROR     		= "UNALLOCATED_SHIFTS_COUNT_ERROR";

export const ADD_REMOVE_VEHICLE           		= "ADD_REMOVE_VEHICLE";
export const ADD_REMOVE_VEHICLE_SUCCESS   		= "ADD_REMOVE_VEHICLE_SUCCESS";
export const ADD_REMOVE_VEHICLE_ERROR     		= "ADD_REMOVE_VEHICLE_ERROR";

export const LIST_INVOICE           		= "LIST_INVOICE";
export const LIST_INVOICE_SUCCESS   		= "LIST_INVOICE_SUCCESS";
export const LIST_INVOICE_ERROR     		= "LIST_INVOICE_ERROR";

export const UPDATE_INVOICE           		= "UPDATE_INVOICE";
export const UPDATE_INVOICE_SUCCESS   		= "UPDATE_INVOICE_SUCCESS";
export const UPDATE_INVOICE_ERROR     		= "UPDATE_INVOICE_ERROR";

export const INVOICE_PREVIEW           		= "INVOICE_PREVIEW";
export const INVOICE_PREVIEW_SUCCESS   		= "INVOICE_PREVIEW_SUCCESS";
export const INVOICE_PREVIEW_ERROR     		= "INVOICE_PREVIEW_ERROR";

export const LIST_VEHICLE_FIELDS_MASTER        = "LIST_VEHICLE_FIELDS_MASTER";
export const LIST_VEHICLE_FIELDS_MASTER_SUCCESS= "LIST_VEHICLE_FIELDS_MASTER_SUCCESS";
export const LIST_VEHICLE_FIELDS_MASTER_ERROR  = "LIST_VEHICLE_FIELDS_MASTER_ERROR";

export const ADD_VEHICLE_FIELDS_MASTER        = "ADD_VEHICLE_FIELDS_MASTER";
export const ADD_VEHICLE_FIELDS_MASTER_SUCCESS= "ADD_VEHICLE_FIELDS_MASTER_SUCCESS";
export const ADD_VEHICLE_FIELDS_MASTER_ERROR  = "ADD_VEHICLE_FIELDS_MASTER_ERROR"; 

export const UPDATE_VEHICLE_FIELDS_MASTER        = "UPDATE_VEHICLE_FIELDS_MASTER";
export const UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS= "UPDATE_VEHICLE_FIELDS_MASTER_SUCCESS";
export const UPDATE_VEHICLE_FIELDS_MASTER_ERROR  = "UPDATE_VEHICLE_FIELDS_MASTER_ERROR"; 

export const DELETE_VEHICLE_FIELDS_MASTER        = "DELETE_VEHICLE_FIELDS_MASTER";
export const DELETE_VEHICLE_FIELDS_MASTER_SUCCESS= "DELETE_VEHICLE_FIELDS_MASTER_SUCCESS";
export const DELETE_VEHICLE_FIELDS_MASTER_ERROR  = "DELETE_VEHICLE_FIELDS_MASTER_ERROR";

export const LIST_FIELD_DETAILS           	= "LIST_FIELD_DETAILS";
export const LIST_FIELD_DETAILS_SUCCESS   	= "LIST_FIELD_DETAILS_SUCCESS";
export const LIST_FIELD_DETAILS_ERROR     	= "LIST_FIELD_DETAILS_ERROR";

export const SAVE_FIELD_DETAILS           		= "SAVE_FIELD_DETAILS";
export const SAVE_FIELD_DETAILS_SUCCESS   		= "SAVE_FIELD_DETAILS_SUCCESS";
export const SAVE_FIELD_DETAILS_ERROR     		= "SAVE_FIELD_DETAILS_ERROR";

export const DELETE_FIELD_DETAILS           		= "DELETE_FIELD_DETAILS";
export const DELETE_FIELD_DETAILS_SUCCESS   		= "DELETE_FIELD_DETAILS_SUCCESS";
export const DELETE_FIELD_DETAILS_ERROR     		= "DELETE_FIELD_DETAILS_ERROR"

export const SAVE_VEHICLE_INFO           		= "SAVE_VEHICLE_INFO";
export const SAVE_VEHICLE_INFO_SUCCESS   		= "SAVE_VEHICLE_INFO_SUCCESS";
export const SAVE_VEHICLE_INFO_ERROR     		= "SAVE_VEHICLE_INFO_ERROR";

export const LIST_VEHICLE_INFO           		= "LIST_VEHICLE_INFO";
export const LIST_VEHICLE_INFO_SUCCESS   		= "LIST_VEHICLE_INFO_SUCCESS";
export const LIST_VEHICLE_INFO_ERROR     		= "LIST_VEHICLE_INFO_ERROR";

export const UPDATE_VEHICLE_INFO           		= "UPDATE_VEHICLE_INFO";
export const UPDATE_VEHICLE_INFO_SUCCESS   		= "UPDATE_VEHICLE_INFO_SUCCESS";
export const UPDATE_VEHICLE_INFO_ERROR     		= "UPDATE_VEHICLE_INFO_ERROR";

export const DELETE_VEHICLE_INFO           		= "DELETE_VEHICLE_INFO";
export const DELETE_VEHICLE_INFO_SUCCESS   		= "DELETE_VEHICLE_INFO_SUCCESS";
export const DELETE_VEHICLE_INFO_ERROR     		= "DELETE_VEHICLE_INFO_ERROR";

export const GET_VEHICLE_INFO           		= "GET_VEHICLE_INFO";
export const GET_VEHICLE_INFO_SUCCESS   		= "GET_VEHICLE_INFO_SUCCESS";
export const GET_VEHICLE_INFO_ERROR     		= "GET_VEHICLE_INFO_ERROR";

export const AVAILABLE_AFF_VEHICLE           	= "AVAILABLE_AFF_VEHICLE";
export const AVAILABLE_AFF_VEHICLE_SUCCESS   	= "AVAILABLE_AFF_VEHICLE_SUCCESS";
export const AVAILABLE_AFF_VEHICLE_ERROR     	= "AVAILABLE_AFF_VEHICLE_ERROR";

export const ADD_AFF_VEHICLE           		    = "ADD_AFF_VEHICLE";
export const ADD_AFF_VEHICLE_SUCCESS   		    = "ADD_AFF_VEHICLE_SUCCESS";
export const ADD_AFF_VEHICLE_ERROR     		    = "ADD_AFF_VEHICLE_ERROR";

export const REMOVE_AFF_VEHICLE           		= "REMOVE_AFF_VEHICLE";
export const REMOVE_AFF_VEHICLE_SUCCESS   		= "REMOVE_AFF_VEHICLE_SUCCESS";
export const REMOVE_AFF_VEHICLE_ERROR     		= "REMOVE_AFF_VEHICLE_ERROR";

export const ADD_REMOVE_VEHICLE_SHIFT           		= "ADD_REMOVE_VEHICLE_SHIFT";
export const ADD_REMOVE_VEHICLE_SHIFT_SUCCESS   		= "ADD_REMOVE_VEHICLE_SHIFT_SUCCESS";
export const ADD_REMOVE_VEHICLE_SHIFT_ERROR     		= "ADD_REMOVE_VEHICLE_SHIFT_ERROR";

export const ADD_AFF_VEHICLE_SHIFT           		    = "ADD_AFF_VEHICLE_SHIFT";
export const ADD_AFF_VEHICLE_SHIFT_SUCCESS   		    = "ADD_AFF_VEHICLE_SHIFT_SUCCESS";
export const ADD_AFF_VEHICLE_SHIFT_ERROR     		    = "ADD_AFF_VEHICLE_SHIFT_ERROR";

export const REMOVE_AFF_VEHICLE_SHIFT           		= "REMOVE_AFF_VEHICLE_SHIFT";
export const REMOVE_AFF_VEHICLE_SHIFT_SUCCESS   		= "REMOVE_AFF_VEHICLE_SHIFT_SUCCESS";
export const REMOVE_AFF_VEHICLE_SHIFT_ERROR     		= "REMOVE_AFF_VEHICLE_SHIFT_ERROR";

export const UPDATE_ASSO_MUTE_EMAIL           		= "UPDATE_ASSO_MUTE_EMAIL";
export const UPDATE_ASSO_MUTE_EMAIL_SUCCESS   		= "UPDATE_ASSO_MUTE_EMAIL_SUCCESS";
export const UPDATE_ASSO_MUTE_EMAIL_ERROR     		= "UPDATE_ASSO_MUTE_EMAIL_ERROR";

export const UPDATE_ASSO_MUTE_PUSH           		= "UPDATE_ASSO_MUTE_PUSH";
export const UPDATE_ASSO_MUTE_PUSH_SUCCESS   		= "UPDATE_ASSO_MUTE_PUSH_SUCCESS";
export const UPDATE_ASSO_MUTE_PUSH_ERROR     		= "UPDATE_ASSO_MUTE_PUSH_ERROR";

export const CANCEL_REASONS_MASTER_LIST             = "CANCEL_REASONS_MASTER_LIST";
export const CANCEL_REASONS_MASTER_LIST_SUCCESS     = "CANCEL_REASONS_MASTER_LIST_SUCCESS";
export const CANCEL_REASONS_MASTER_LIST_ERROR       = "CANCEL_REASONS_MASTER_LIST_ERROR";

export const CANCEL_REASONS_MASTER_ADD              = "CANCEL_REASONS_MASTER_ADD";
export const CANCEL_REASONS_MASTER_ADD_SUCCESS      = "CANCEL_REASONS_MASTER_ADD_SUCCESS";
export const CANCEL_REASONS_MASTER_ADD_ERROR        = "CANCEL_REASONS_MASTER_ADD_ERROR";

export const CANCEL_REASONS_MASTER_LOAD             = 'CANCEL_REASONS_MASTER_LOAD';
export const CANCEL_REASONS_MASTER_LOAD_SUCCESS     = "CANCEL_REASONS_MASTER_LOAD_SUCCESS";
export const CANCEL_REASONS_MASTER_LOAD_ERROR       = "CANCEL_REASONS_MASTER_LOAD_ERROR";

export const CANCEL_REASONS_MASTER_MODIFY           = "CANCEL_REASONS_MASTER_MODIFY";
export const CANCEL_REASONS_MASTER_MODIFY_SUCCESS   = "CANCEL_REASONS_MASTER_MODIFY_SUCCESS";
export const CANCEL_REASONS_MASTER_MODIFY_ERROR     = "CANCEL_REASONS_MASTER_MODIFY_ERROR";

export const CANCEL_REASONS_MASTER_DELETE           = "CANCEL_REASONS_MASTER_DELETE";
export const CANCEL_REASONS_MASTER_DELETE_SUCCESS   = "CANCEL_REASONS_MASTER_DELETE_SUCCESS";
export const CANCEL_REASONS_MASTER_DELETE_ERROR     = "CANCEL_REASONS_MASTER_DELETE_ERROR";

export const CANCEL_REASONS_LIST                    = "CANCEL_REASONS_LIST";
export const CANCEL_REASONS_LIST_SUCCESS            = "CANCEL_REASONS_LIST_SUCCESS";
export const CANCEL_REASONS_LIST_ERROR              = "CANCEL_REASONS_LIST_ERROR";

export const CANCEL_REASONS_ADD                     = "CANCEL_REASONS_ADD";
export const CANCEL_REASONS_ADD_SUCCESS             = "CANCEL_REASONS_ADD_SUCCESS";
export const CANCEL_REASONS_ADD_ERROR               = "CANCEL_REASONS_ADD_ERROR";

export const CANCEL_REASONS_LOAD                    = 'CANCEL_REASONS_LOAD';
export const CANCEL_REASONS_LOAD_SUCCESS            = "CANCEL_REASONS_LOAD_SUCCESS";
export const CANCEL_REASONS_LOAD_ERROR              = "CANCEL_REASONS_LOAD_ERROR";

export const CANCEL_REASONS_MODIFY                  = "CANCEL_REASONS_MODIFY";
export const CANCEL_REASONS_MODIFY_SUCCESS          = "CANCEL_REASONS_MODIFY_SUCCESS";
export const CANCEL_REASONS_MODIFY_ERROR            = "CANCEL_REASONS_MODIFY_ERROR";

export const CANCEL_REASONS_DELETE                  = "CANCEL_REASONS_DELETE";
export const CANCEL_REASONS_DELETE_SUCCESS          = "CANCEL_REASONS_DELETE_SUCCESS";
export const CANCEL_REASONS_DELETE_ERROR            = "CANCEL_REASONS_DELETE_ERROR";

export const CANCELLED_REASON_LIST           		= "CANCELLED_REASON_LIST";
export const CANCELLED_REASON_LIST_SUCCESS   		= "CANCELLED_REASON_LIST_SUCCESS";
export const CANCELLED_REASON_LIST_ERROR     		= "CANCELLED_REASON_LIST_ERROR";

export const TERMS_FETCH           		            = "TERMS_FETCH";
export const TERMS_FETCH_SUCCESS   		            = "TERMS_FETCH_SUCCESS";
export const TERMS_FETCH_ERROR     		            = "TERMS_FETCH_ERROR";

export const TERMS_ADD           		            = "TERMS_ADD";
export const TERMS_ADD_SUCCESS   		            = "TERMS_ADD_SUCCESS";
export const TERMS_ADD_ERROR     		            = "TERMS_ADD_ERROR";

export const TERMS_UPDATE           		        = "TERMS_UPDATE";
export const TERMS_UPDATE_SUCCESS   		        = "TERMS_UPDATE_SUCCESS";
export const TERMS_UPDATE_ERROR     		        = "TERMS_UPDATE_ERROR";

export const TERMS_LOAD           		            = "TERMS_LOAD";
export const TERMS_LOAD_SUCCESS   		            = "TERMS_LOAD_SUCCESS";
export const TERMS_LOAD_ERROR     		            = "TERMS_LOAD_ERROR";

export const TERMS_ACCEPT           		            = "TERMS_ACCEPT";
export const TERMS_ACCEPT_SUCCESS   		            = "TERMS_ACCEPT_SUCCESS";
export const TERMS_ACCEPT_ERROR     		            = "TERMS_ACCEPT_ERROR";

export const ACTION_TAKEN_SHIFT           		    = "ACTION_TAKEN_SHIFT";
export const ACTION_TAKEN_SHIFT_SUCCESS   		    = "ACTION_TAKEN_SHIFT_SUCCESS";
export const ACTION_TAKEN_SHIFT_ERROR     		    = "ACTION_TAKEN_SHIFT_ERROR";

export const ACTION_TAKEN_SHIFT_UPDATE              = "ACTION_TAKEN_SHIFT_UPDATE";
export const ACTION_TAKEN_SHIFT_UPDATE_SUCCESS      = "ACTION_TAKEN_SHIFT_UPDATE_SUCCESS";
export const ACTION_TAKEN_SHIFT_UPDATE_ERROR        = "ACTION_TAKEN_SHIFT_UPDATE_ERROR";

export const ACTION_TAKEN_CREW           		    = "ACTION_TAKEN_CREW";
export const ACTION_TAKEN_CREW_SUCCESS   		    = "ACTION_TAKEN_CREW_SUCCESS";
export const ACTION_TAKEN_CREW_ERROR     		    = "ACTION_TAKEN_CREW_ERROR";

export const ACTION_TAKEN_CREW_UPDATE               = "ACTION_TAKEN_CREW_UPDATE";
export const ACTION_TAKEN_CREW_UPDATE_SUCCESS       = "ACTION_TAKEN_CREW_UPDATE_SUCCESS";
export const ACTION_TAKEN_CREW_UPDATE_ERROR         = "ACTION_TAKEN_CREW_UPDATE_ERROR";

export const CREW_AVAILABILITY_REPORT           	= "CREW_AVAILABILITY_REPORT";
export const CREW_AVAILABILITY_REPORT_SUCCESS   	= "CREW_AVAILABILITY_REPORT_SUCCESS";
export const CREW_AVAILABILITY_REPORT_ERROR     	= "CREW_AVAILABILITY_REPORT_ERROR ";

export const CREW_UNAPPROVED_COUNT           	= "CREW_UNAPPROVED_COUNT";
export const CREW_UNAPPROVED_COUNT_SUCCESS   	= "CREW_UNAPPROVED_COUNT_SUCCESS";
export const CREW_UNAPPROVED_COUNT_ERROR     	= "CREW_UNAPPROVED_COUNT_ERROR ";

export const RATE_CARDS_LIST_AFFILIATE          = "RATE_CARDS_LIST_AFFILIATE";
export const RATE_CARDS_LIST_AFFILIATE_SUCCESS  = "RATE_CARDS_LIST_AFFILIATE_SUCCESS";
export const RATE_CARDS_LIST_AFFILIATE_ERROR    = "RATE_CARDS_LIST_AFFILIATE_ERROR";

export const RATE_CARDS_ALL_AFFILIATE          = "RATE_CARDS_ALL_AFFILIATE";
export const RATE_CARDS_ALL_AFFILIATE_SUCCESS  = "RATE_CARDS_ALL_AFFILIATE_SUCCESS";
export const RATE_CARDS_ALL_AFFILIATE_ERROR    = "RATE_CARDS_ALL_AFFILIATE_ERROR";

export const RATE_CARDS_ADD_AFFILIATE           = "RATE_CARDS_ADD_AFFILIATE";
export const RATE_CARDS_ADD_AFFILIATE_SUCCESS   = "RATE_CARDS_ADD_AFFILIATE_SUCCESS";
export const RATE_CARDS_ADD_AFFILIATE_ERROR     = "RATE_CARDS_ADD_AFFILIATE_ERROR";

export const RATE_CARDS_UPDATE_AFFILIATE        = "RATE_CARDS_UPDATE_AFFILIATE";
export const RATE_CARDS_UPDATE_AFFILIATE_SUCCESS= "RATE_CARDS_UPDATE_AFFILIATE_SUCCESS";
export const RATE_CARDS_UPDATE_AFFILIATE_ERROR  = "RATE_CARDS_UPDATE_AFFILIATE_ERROR";

export const RATE_CARDS_DELETE_AFFILIATE        = "RATE_CARDS_DELETE_AFFILIATE";
export const RATE_CARDS_DELETE_AFFILIATE_SUCCESS= "RATE_CARDS_DELETE_AFFILIATE_SUCCESS";
export const RATE_CARDS_DELETE_AFFILIATE_ERROR  = "RATE_CARDS_DELETE_AFFILIATE_ERROR";

export const DEPT_RATECARDS_LIST        = "DEPT_RATECARDS_LIST";
export const DEPT_RATECARDS_LIST_SUCCESS= "DEPT_RATECARDS_LIST_SUCCESS";
export const DEPT_RATECARDS_LIST_ERROR  = "DEPT_RATECARDS_LIST_ERROR";

export const DEPT_RATECARDS_UPDATE        = "DEPT_RATECARDS_UPDATE";
export const DEPT_RATECARDS_UPDATE_SUCCESS= "DEPT_RATECARDS_UPDATE_SUCCESS";
export const DEPT_RATECARDS_UPDATE_ERROR  = "DEPT_RATECARDS_UPDATE_ERROR";

export const RATECARD_CHEIF_BONUS_GET        = "RATECARD_CHEIF_BONUS_GET";
export const RATECARD_CHEIF_BONUS_GET_SUCCESS= "RATECARD_CHEIF_BONUS_GET_SUCCESS";
export const RATECARD_CHEIF_BONUS_GET_ERROR  = "RATECARD_CHEIF_BONUS_GET_ERROR";

export const RATECARD_CHEIF_BONUS_UPDATE        = "RATECARD_CHEIF_BONUS_UPDATE";
export const RATECARD_CHEIF_BONUS_UPDATE_SUCCESS= "RATECARD_CHEIF_BONUS_UPDATE_SUCCESS";
export const RATECARD_CHEIF_BONUS_UPDATE_ERROR  = "RATECARD_CHEIF_BONUS_UPDATE_ERROR";

export const SET_DEFAULT_RATE_CARD_ID= "SET_DEFAULT_RATE_CARD_ID";

export const RATE_CARD_LIST          = "RATE_CARD_LIST";
export const RATE_CARD_LIST_SUCCESS  = "RATE_CARD_LIST_SUCCESS";
export const RATE_CARD_LIST_ERROR    = "RATE_CARD_LIST_ERROR";

export const RATE_CARD_UPDATE        = "RATE_CARD_UPDATE";
export const RATE_CARD_UPDATE_SUCCESS= "RATE_CARD_UPDATE_SUCCESS";
export const RATE_CARD_UPDATE_ERROR  = "RATE_CARD_UPDATE_ERROR";

export const SET_RATE_CARD_SUBTITLE  = "SET_RATE_CARD_SUBTITLE";

export const EVENT_CLIENT_DEPARTMENTS_LIST        = "EVENT_CLIENT_DEPARTMENTS_LIST";
export const EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS= "EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS";
export const EVENT_CLIENT_DEPARTMENTS_LIST_ERROR  = "EVENT_CLIENT_DEPARTMENTS_LIST_ERROR";

export const CLIENT_DEPARTMENTS_LIST        = "CLIENT_DEPARTMENTS_LIST";
export const CLIENT_DEPARTMENTS_LIST_SUCCESS= "CLIENT_DEPARTMENTS_LIST_SUCCESS";
export const CLIENT_DEPARTMENTS_LIST_ERROR  = "CLIENT_DEPARTMENTS_LIST_ERROR";

export const CREW_NOTES_LIST        = "CREW_NOTES_LIST";
export const CREW_NOTES_LIST_SUCCESS= "CREW_NOTES_LIST_SUCCESS";
export const CREW_NOTES_LIST_ERROR  = "CREW_NOTES_LIST_ERROR";

export const CREW_NOTES_ADD        = "CREW_NOTES_ADD";
export const CREW_NOTES_ADD_SUCCESS= "CREW_NOTES_ADD_SUCCESS";
export const CREW_NOTES_ADD_ERROR  = "CREW_NOTES_ADD_ERROR";

export const CREW_NOTES_DOCUMENT_ADD        = "CREW_NOTES_DOCUMENT_ADD";
export const CREW_NOTES_DOCUMENT_ADD_SUCCESS= "CREW_NOTES_DOCUMENT_ADD_SUCCESS";
export const CREW_NOTES_DOCUMENT_ADD_ERROR  = "CREW_NOTES_DOCUMENT_ADD_ERROR";

export const CREW_NOTES_DOCUMENT_DELETE        = "CREW_NOTES_DOCUMENT_DELETE";
export const CREW_NOTES_DOCUMENT_DELETE_SUCCESS= "CREW_NOTES_DOCUMENT_DELETE_SUCCESS";
export const CREW_NOTES_DOCUMENT_DELETE_ERROR  = "CREW_NOTES_DOCUMENT_DELETE_ERROR";

export const CREW_AVAIL_SUMMARY_REPORT           	= "CREW_AVAIL_SUMMARY_REPORT";
export const CREW_AVAIL_SUMMARY_REPORT_SUCCESS   	= "CREW_AVAIL_SUMMARY_REPORT_SUCCESS";
export const CREW_AVAIL_SUMMARY_REPORT_ERROR     	= "CREW_AVAIL_SUMMARY_REPORT_ERROR ";

export const PASSPORT_FILE_SAVE        = "PASSPORT_FILE_SAVE";
export const PASSPORT_FILE_SAVE_SUCCESS= "PASSPORT_FILE_SAVE_SUCCESS";
export const PASSPORT_FILE_SAVE_ERROR  = "PASSPORT_FILE_SAVE_ERROR";

export const VISA_FILE_SAVE        = "VISA_FILE_SAVE";
export const VISA_FILE_SAVE_SUCCESS= "VISA_FILE_SAVE_SUCCESS";
export const VISA_FILE_SAVE_ERROR  = "VISA_FILE_SAVE_ERROR";

export const CSV_TEMPLATE_IMPORT            = "CSV_TEMPLATE_IMPORT";
export const CSV_TEMPLATE_IMPORT_SUCCESS    = 'CSV_TEMPLATE_IMPORT_SUCCESS';
export const CSV_TEMPLATE_IMPORT_ERROR      = 'CSV_TEMPLATE_IMPORT_ERROR';

export const AFFILIATE_TRAVEL_SETTINGS_LIST          = 'AFFILIATE_TRAVEL_SETTINGS_LIST';
export const AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS  = 'AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS';
export const AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR    = 'AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR';

export const SHIFT_CALENDAR_EVENT_LIST          = 'SHIFT_CALENDAR_EVENT_LIST';
export const SHIFT_CALENDAR_EVENT_LIST_SUCCESS  = 'SHIFT_CALENDAR_EVENT_LIST_SUCCESS';
export const SHIFT_CALENDAR_EVENT_LIST_ERROR    = 'SHIFT_CALENDAR_EVENT_LIST_ERROR';

export const SHIFT_CALENDAR_EVENT_SHIFT_LIST          = 'SHIFT_CALENDAR_EVENT_SHIFT_LIST';
export const SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS  = 'SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS';
export const SHIFT_CALENDAR_EVENT_SHIFT_LIST_ERROR    = 'SHIFT_CALENDAR_EVENT_SHIFT_LIST_ERROR';

export const SHIFT_CALC_DISTANCE_DEPT_LOC          = 'SHIFT_CALC_DISTANCE_DEPT_LOC';
export const SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS  = 'SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS';
export const SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR    = 'SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR';